/*
 * @Author: AI Assistant
 * @Date: 2026-01-17
 * @Description: API 页面相关的国际化文案
 * @FilePath: /weryai-web/locales/modules/api.ts
 */
export default {
    zh: {
        // Tab 导航
        discovery: '探索',
        discoveryH1: '一站式探索所有主流 AI 图像与视频模型 API',
        docs: '文档',
        apiKeys: 'API 密钥',
        history: '历史',
        pricing: '价格',
        contact: '联系',

        // SEO
        pageTitle: 'API 文档 - 微鲤AI',
        pageDescription: '微鲤AI API 文档 - 提供完整的 API 接口说明和使用指南',

        // Discovery 页面
        coreCapabilities: '核心能力',
        coreCapabilitiesDesc: '探索 Wery AI 提供的全方位生成式 AI 能力。',
        supportedModels: '支持模型',
        supportedModelsDesc: '平台集成的业界顶尖视频与图像模型。',
        video: '视频',
        image: '图像',

        // 能力卡片
        textToImage: '文生图',
        textToImageDesc: '通过文本描述生成高质量图片',
        imageToImage: '图生图',
        imageToImageDesc: '基于参考图生成新的图片',
        textToVideo: '文生视频',
        textToVideoDesc: '将文本脚本转化为动态视频',
        imageToVideo: '图生视频',
        imageToVideoDesc: '让静态图片动起来',
        multiImageToVideo: '多图生视频',
        multiImageToVideoDesc: '多张图片生成连贯视频',
        podcast: 'AI 播客',
        podcastDesc: '生成多角色对话音频',
        music: 'AI 音乐',
        musicDesc: '创作原创背景音乐',
        digitalAvatar: 'AI 数字人',
        digitalAvatarDesc: '生成口型同步的数字人视频',

        // Docs 页面
        docsPageTitle: 'Docs 页面',
        docsPageDesc: '这是 Docs 页面，用于展示 API 文档',

        // Keys 页面
        keysTitle: 'API 密钥',
        keysDesc: '管理您的 API 访问密钥。',
        createNewKey: '创建新密钥',
        description: '描述',
        secretKey: 'Secret Key',
        createTime: '创建时间',
        actions: '操作',
        noKeys: '暂无 API 密钥',
        createFirstKey: '创建第一个密钥',
        createKeyTitle: '创建 API Key',
        keyNameLabel: '密钥名称 / 描述',
        keyNamePlaceholder: '例如：生产环境应用',
        cancel: '取消',
        create: '创建',
        creating: '创建中...',
        deleteConfirm: '删除确认',
        deleteMessage: '确定要删除密钥',
        deleteWarning: '吗？此操作无法撤销。',
        delete: '删除',
        copied: '已复制到剪贴板',
        copyFailed: '复制失败',
        createSuccess: '密钥创建成功',
        createFailed: '创建失败',
        deleteSuccess: '密钥删除成功',
        deleteFailed: '删除失败',
        pleaseEnterDesc: '请输入密钥描述',

        // History 页面
        historyTitle: '任务历史',
        historyDesc: '监控您的 API 调用状态、延迟和费用消耗。',
        searchId: '搜索ID',
        filter: '筛选',
        allStatus: '全部状态',
        onlySuccess: '仅显示成功',
        onlyFailed: '仅显示失败',
        processing: '进行中',
        taskId: '任务 ID',
        model: '模型',
        status: '状态',
        latency: '延迟',
        cost: '费用',
        time: '时间',
        success: '成功',
        failed: '失败',
        noRecords: '暂无历史记录',
        loadMore: '加载更多',
        noMore: '没有更多了',
        requestId: 'Request ID',
        method: '方法',
        operationType: '类型',
        duration: '耗时',
        costCredits: '费用 (积分)',
        paginationText: '显示 {from} 到 {to} 条，共 {total} 条记录',

        // Contact 页面
        needHelp: '需要帮助？',
        contactDesc:
            '无论是 API 集成问题、企业定制需求，还是提升配额，我们的技术团队都会在 24 小时内给予响应支持。',
        techSupport: '技术支持邮箱',
        supportTime:
            '周一至周日 09:00-23:00 (GMT+8)。企业客户可开通 7x24 小时 VIP 通道。',
        sendEmail: '发送邮件',
        viewDocs: '查看文档',

        // Pricing 页面
        pricingTitle: '价格与计费',
        pricingDesc: '灵活的按量付费模式，用多少付多少。',
        currentBalance: '当前金币余额',
        credits: '积分',
        billingRecords: '账单记录',
        buyCredits: '购买积分',
        priceLabel: '价格',
        creditsLabel: '积分',
        unitPrice: '单价',
        loading: '加载中...',
        buySelected: '购买选中套餐',
        modelRates: '模型消耗费率',
        modelLabel: '模型',
        consumptionLabel: '消耗',
        weryPrice: 'Wery 价格',
        competitorA: '竞品 A',
        competitorB: '竞品 B',
    },
    en: {
        // Tab Navigation
        discovery: 'Discovery',
        discoveryH1: 'Explore All AI Image & Video Model APIs in ONE Platform',
        docs: 'Docs',
        apiKeys: 'API Keys',
        history: 'History',
        pricing: 'Pricing',
        contact: 'Contact',

        // SEO
        pageTitle: 'API Documentation - 微鲤AI',
        pageDescription:
            '微鲤AI API Documentation - Complete API interface description and usage guide',

        // Discovery Page
        coreCapabilities: 'Core Capabilities',
        coreCapabilitiesDesc:
            'Explore the full range of generative AI capabilities provided by Wery AI.',
        supportedModels: 'Supported Models',
        supportedModelsDesc:
            'Industry-leading video and image models integrated into the platform.',
        video: 'Video',
        image: 'Image',

        // Capability Cards
        textToImage: 'Text to Image',
        textToImageDesc: 'Generate high-quality images from text',
        imageToImage: 'Image to Image',
        imageToImageDesc: 'Create new images based on reference',
        textToVideo: 'Text to Video',
        textToVideoDesc: 'Transform text scripts into videos',
        imageToVideo: 'Image to Video',
        imageToVideoDesc: 'Bring static images to life',
        multiImageToVideo: 'Multi-Image to Video',
        multiImageToVideoDesc: 'Create videos from multiple images',
        podcast: 'AI Podcast',
        podcastDesc: 'Generate multi-character dialogue audio',
        music: 'AI Music',
        musicDesc: 'Create original background music',
        digitalAvatar: 'AI Avatar',
        digitalAvatarDesc: 'Generate lip-synced avatar videos',

        // Docs Page
        docsPageTitle: 'Docs Page',
        docsPageDesc: 'This is the Docs page for API documentation',

        // Keys Page
        keysTitle: 'API Keys',
        keysDesc: 'Manage your API access keys.',
        createNewKey: 'Create New Key',
        description: 'Description',
        secretKey: 'Secret Key',
        createTime: 'Created',
        actions: 'Actions',
        noKeys: 'No API keys yet',
        createFirstKey: 'Create your first key',
        createKeyTitle: 'Create API Key',
        keyNameLabel: 'Key Name / Description',
        keyNamePlaceholder: 'e.g., Production App',
        cancel: 'Cancel',
        create: 'Create',
        creating: 'Creating...',
        deleteConfirm: 'Delete Confirmation',
        deleteMessage: 'Are you sure you want to delete key',
        deleteWarning: '? This action cannot be undone.',
        delete: 'Delete',
        copied: 'Copied to clipboard',
        copyFailed: 'Copy failed',
        createSuccess: 'Key created successfully',
        createFailed: 'Creation failed',
        deleteSuccess: 'Key deleted successfully',
        deleteFailed: 'Deletion failed',
        pleaseEnterDesc: 'Please enter key description',

        // History Page
        historyTitle: 'Task History',
        historyDesc: 'Monitor your API call status, latency, and cost.',
        searchId: 'Search ID',
        filter: 'Filter',
        allStatus: 'All Status',
        onlySuccess: 'Success Only',
        onlyFailed: 'Failed Only',
        processing: 'Processing',
        taskId: 'Task ID',
        model: 'Model',
        status: 'Status',
        latency: 'Latency',
        cost: 'Cost',
        time: 'Time',
        success: 'Success',
        failed: 'Failed',
        noRecords: 'No history records',
        loadMore: 'Load More',
        noMore: 'No more',
        requestId: 'Request ID',
        method: 'Method',
        operationType: 'Type',
        duration: 'Duration',
        costCredits: 'Cost (Credits)',
        paginationText: 'Showing {from} to {to} of {total} records',

        // Contact Page
        needHelp: 'Need Help?',
        contactDesc:
            "Whether it's API integration issues, enterprise customization, or quota upgrades, our technical team will respond within 24 hours.",
        techSupport: 'Technical Support Email',
        supportTime:
            'Mon-Sun 09:00-23:00 (GMT+8). Enterprise customers can access 7x24 VIP support.',
        sendEmail: 'Send Email',
        viewDocs: 'View Docs',

        // Pricing Page
        pricingTitle: 'Pricing & Billing',
        pricingDesc: 'Flexible pay-as-you-go model, pay for what you use.',
        currentBalance: 'Current Balance',
        credits: 'Credits',
        billingRecords: 'Billing Records',
        buyCredits: 'Buy Credits',
        priceLabel: 'Price',
        creditsLabel: 'Credits',
        unitPrice: 'Unit Price',
        loading: 'Loading...',
        buySelected: 'Buy Selected Package',
        modelRates: 'Model Usage Rates',
        modelLabel: 'Model',
        consumptionLabel: 'Consumption',
        weryPrice: 'Wery Price',
        competitorA: 'Competitor A',
        competitorB: 'Competitor B',
    },
    ja: {
        // タブナビゲーション
        discovery: '発見',
        discoveryH1: 'すべての主要な AI ビデオおよび画像モデル API を 1 つのプラットフォームで探索',
        docs: 'ドキュメント',
        apiKeys: 'APIキー',
        history: '履歴',
        pricing: '料金',
        contact: 'お問い合わせ',

        // SEO
        pageTitle: 'API ドキュメント - 微鲤AI',
        pageDescription:
            '微鲤AI API ドキュメント - 完全な API インターフェースの説明と使用ガイド',

        // Discoveryページ
        coreCapabilities: 'コア機能',
        coreCapabilitiesDesc: 'Wery AIの包括的な生成AI機能を探索',
        supportedModels: 'サポートモデル',
        supportedModelsDesc: '業界トップクラスの動画・画像モデルを統合',
        video: '動画',
        image: '画像',

        // 機能カード
        textToImage: 'テキストから画像',
        textToImageDesc: 'テキストから高品質な画像を生成',
        imageToImage: '画像から画像',
        imageToImageDesc: '参考画像から新しい画像を作成',
        textToVideo: 'テキストから動画',
        textToVideoDesc: 'テキストを動画に変換',
        imageToVideo: '画像から動画',
        imageToVideoDesc: '静止画を動画化',
        multiImageToVideo: '複数画像から動画',
        multiImageToVideoDesc: '複数の画像から動画を作成',
        podcast: 'AIポッドキャスト',
        podcastDesc: '多人数対話音声を生成',
        music: 'AI音楽',
        musicDesc: 'オリジナル音楽を作成',
        digitalAvatar: 'AIアバター',
        digitalAvatarDesc: 'リップシンク動画を生成',

        // Docsページ
        docsPageTitle: 'Docsページ',
        docsPageDesc: 'APIドキュメントを展示するDocsページです',

        // Keysページ
        keysTitle: 'APIキー',
        keysDesc: 'APIアクセスキーを管理します。',
        createNewKey: '新しいキーを作成',
        description: '説明',
        secretKey: 'シークレットキー',
        createTime: '作成日時',
        actions: '操作',
        noKeys: 'まだAPIキーがありません',
        createFirstKey: '最初のキーを作成',
        createKeyTitle: 'APIキーを作成',
        keyNameLabel: 'キー名 / 説明',
        keyNamePlaceholder: '例：本番環境アプリ',
        cancel: 'キャンセル',
        create: '作成',
        creating: '作成中...',
        deleteConfirm: '削除確認',
        deleteMessage: 'キーを削除してもよろしいですか',
        deleteWarning: '？この操作は元に戻せません。',
        delete: '削除',
        copied: 'クリップボードにコピーしました',
        copyFailed: 'コピーに失敗しました',
        createSuccess: 'キーを作成しました',
        createFailed: '作成に失敗しました',
        deleteSuccess: 'キーを削除しました',
        deleteFailed: '削除に失敗しました',
        pleaseEnterDesc: 'キーの説明を入力してください',

        // Historyページ
        historyTitle: 'タスク履歴',
        historyDesc: 'API呼び出しのステータス、レイテンシー、コストを監視します。',
        searchId: 'IDを検索',
        filter: 'フィルター',
        allStatus: 'すべてのステータス',
        onlySuccess: '成功のみ',
        onlyFailed: '失敗のみ',
        processing: '処理中',
        taskId: 'タスクID',
        model: 'モデル',
        status: 'ステータス',
        latency: 'レイテンシー',
        cost: 'コスト',
        time: '時間',
        success: '成功',
        failed: '失敗',
        noRecords: '履歴記録がありません',
        loadMore: 'さらに読み込む',
        noMore: 'これ以上ありません',
        requestId: 'リクエストID',
        method: 'メソッド',
        operationType: 'タイプ',
        duration: '処理時間',
        costCredits: 'コスト (クレジット)',
        paginationText: '{from} から {to} までを表示、全 {total} 件',

        // Contactページ
        needHelp: 'ヘルプが必要ですか？',
        contactDesc:
            'API統合の問題、企業向けカスタマイズ、クォータの引き上げなど、技術チームが24時間以内に対応いたします。',
        techSupport: 'テクニカルサポートメール',
        supportTime:
            '月曜日〜日曜日 09:00-23:00 (GMT+8)。企業のお客様は7x24時間VIPサポートをご利用いただけます。',
        sendEmail: 'メールを送信',
        viewDocs: 'ドキュメントを見る',

        // Pricingページ
        pricingTitle: '料金と請求',
        pricingDesc: '柔軟な従量課金モデル、使った分だけお支払い。',
        currentBalance: '現在の残高',
        credits: 'クレジット',
        billingRecords: '請求記録',
        buyCredits: 'クレジットを購入',
        priceLabel: '価格',
        creditsLabel: 'クレジット',
        unitPrice: '単価',
        loading: '読み込み中...',
        buySelected: '選択したパッケージを購入',
        modelRates: 'モデル使用料金',
        modelLabel: 'モデル',
        consumptionLabel: '消費',
        weryPrice: 'Wery 価格',
        competitorA: '競合他社 A',
        competitorB: '競合他社 B',
    },
    ko: {
        // 탭 네비게이션
        discovery: '탐색',
        discoveryH1: '모든 주요 AI 비디오 및 이미지 모델 API를 한곳에서 탐색',
        docs: '문서',
        apiKeys: 'API 키',
        history: '기록',
        pricing: '가격',
        contact: '연락처',

        // SEO
        pageTitle: 'API 문서 - 微鲤AI',
        pageDescription:
            '微鲤AI API 문서 - 완전한 API 인터페이스 설명 및 사용 가이드',

        // Discovery 페이지
        coreCapabilities: '핵심 기능',
        coreCapabilitiesDesc: 'Wery AI의 포괄적인 생성형 AI 기능 탐색',
        supportedModels: '지원 모델',
        supportedModelsDesc: '업계 최고의 동영상 및 이미지 모델 통합',
        video: '동영상',
        image: '이미지',

        // 기능 카드
        textToImage: '텍스트-이미지',
        textToImageDesc: '텍스트로 고품질 이미지 생성',
        imageToImage: '이미지-이미지',
        imageToImageDesc: '참조 이미지로 새 이미지 생성',
        textToVideo: '텍스트-동영상',
        textToVideoDesc: '텍스트를 동영상으로 변환',
        imageToVideo: '이미지-동영상',
        imageToVideoDesc: '정적 이미지를 동영상으로',
        multiImageToVideo: '다중이미지-동영상',
        multiImageToVideoDesc: '여러 이미지로 동영상 생성',
        podcast: 'AI 팟캐스트',
        podcastDesc: '다중 대화 오디오 생성',
        music: 'AI 음악',
        musicDesc: '오리지널 음악 창작',
        digitalAvatar: 'AI 아바타',
        digitalAvatarDesc: '립싱크 아바타 동영상 생성',

        // Docs 페이지
        docsPageTitle: 'Docs 페이지',
        docsPageDesc: 'API 문서를 위한 Docs 페이지입니다',

        // Keys 페이지
        keysTitle: 'API 키',
        keysDesc: 'API 액세스 키를 관리합니다.',
        createNewKey: '새 키 만들기',
        description: '설명',
        secretKey: '비밀 키',
        createTime: '생성일',
        actions: '작업',
        noKeys: '아직 API 키가 없습니다',
        createFirstKey: '첫 번째 키 만들기',
        createKeyTitle: 'API 키 생성',
        keyNameLabel: '키 이름 / 설명',
        keyNamePlaceholder: '예: 프로덕션 앱',
        cancel: '취소',
        create: '생성',
        creating: '생성 중...',
        deleteConfirm: '삭제 확인',
        deleteMessage: '키를 삭제하시겠습니까',
        deleteWarning: '? 이 작업은 취소할 수 없습니다.',
        delete: '삭제',
        copied: '클립보드에 복사됨',
        copyFailed: '복사 실패',
        createSuccess: '키가 생성되었습니다',
        createFailed: '생성 실패',
        deleteSuccess: '키가 삭제되었습니다',
        deleteFailed: '삭제 실패',
        pleaseEnterDesc: '키 설명을 입력하세요',

        // History 페이지
        historyTitle: '작업 기록',
        historyDesc: 'API 호출 상태, 지연 시간 및 비용을 모니터링합니다.',
        searchId: 'ID 검색',
        filter: '필터',
        allStatus: '모든 상태',
        onlySuccess: '성공만',
        onlyFailed: '실패만',
        processing: '처리 중',
        taskId: '작업 ID',
        model: '모델',
        status: '상태',
        latency: '지연 시간',
        cost: '비용',
        time: '시간',
        success: '성공',
        failed: '실패',
        noRecords: '기록이 없습니다',
        loadMore: '더 보기',
        noMore: '더 이상 없음',
        requestId: '요청 ID',
        method: '메서드',
        operationType: '유형',
        duration: '소요 시간',
        costCredits: '비용 (크레딧)',
        paginationText: '{from}부터 {to}까지 표시, 총 {total}개',

        // Contact 페이지
        needHelp: '도움이 필요하신가요?',
        contactDesc:
            'API 통합 문제, 기업 맞춤화 또는 할당량 증가 등 모든 문제에 대해 기술팀이 24시간 내에 답변드립니다.',
        techSupport: '기술 지원 이메일',
        supportTime:
            '월-일 09:00-23:00 (GMT+8). 기업 고객은 연중무휴 VIP 지원을 이용하실 수 있습니다.',
        sendEmail: '이메일 보내기',
        viewDocs: '문서 보기',

        // Pricing 페이지
        pricingTitle: '가격 및 청구',
        pricingDesc: '유연한 사용량 기반 요금제, 사용한 만큼만 지불하세요.',
        currentBalance: '현재 잔액',
        credits: '크레딧',
        billingRecords: '청구 기록',
        buyCredits: '크레딧 구매',
        priceLabel: '가격',
        creditsLabel: '크레딧',
        unitPrice: '단가',
        loading: '로딩 중...',
        buySelected: '선택한 패키지 구매',
        modelRates: '모델 사용 요금',
        modelLabel: '모델',
        consumptionLabel: '소비',
        weryPrice: 'Wery 가격',
        competitorA: '경쟁사 A',
        competitorB: '경쟁사 B',
    },
    es: {
        // Navegación de pestañas
        discovery: 'Explorar',
        discoveryH1: 'Explore todas las API de modelos de IA de vídeo e imagen en una sola plataforma',
        docs: 'Documentos',
        apiKeys: 'Claves API',
        history: 'Historial',
        pricing: 'Precios',
        contact: 'Contacto',

        // SEO
        pageTitle: 'Documentación API - 微鲤AI',
        pageDescription:
            'Documentación de la API de 微鲤AI - Descripción completa de la interfaz API y guía de uso',

        // Página Discovery
        coreCapabilities: 'Capacidades Principales',
        coreCapabilitiesDesc:
            'Explora las capacidades de IA generativa de Wery AI',
        supportedModels: 'Modelos Soportados',
        supportedModelsDesc: 'Modelos líderes de video e imagen integrados',
        video: 'Vídeo',
        image: 'Imagen',

        // Tarjetas de capacidades
        textToImage: 'Texto a Imagen',
        textToImageDesc: 'Genera imágenes desde texto',
        imageToImage: 'Imagen a Imagen',
        imageToImageDesc: 'Crea nuevas imágenes desde referencia',
        textToVideo: 'Texto a Video',
        textToVideoDesc: 'Convierte texto en video',
        imageToVideo: 'Imagen a Video',
        imageToVideoDesc: 'Anima imágenes estáticas',
        multiImageToVideo: 'Multi-Imagen a Video',
        multiImageToVideoDesc: 'Crea videos desde múltiples imágenes',
        podcast: 'Podcast IA',
        podcastDesc: 'Genera audio multi-personaje',
        music: 'Música IA',
        musicDesc: 'Crea música original',
        digitalAvatar: 'Avatar IA',
        digitalAvatarDesc: 'Genera videos de avatar sincronizados',

        // Página Docs
        docsPageTitle: 'Página Docs',
        docsPageDesc: 'Esta es la página Docs para documentación API',

        // Página Keys
        keysTitle: 'Claves API',
        keysDesc: 'Administra tus claves de acceso API.',
        createNewKey: 'Crear Nueva Clave',
        description: 'Descripción',
        secretKey: 'Clave Secreta',
        createTime: 'Creada',
        actions: 'Acciones',
        noKeys: 'Aún no hay claves API',
        createFirstKey: 'Crea tu primera clave',
        createKeyTitle: 'Crear Clave API',
        keyNameLabel: 'Nombre de Clave / Descripción',
        keyNamePlaceholder: 'ej. Aplicación de Producción',
        cancel: 'Cancelar',
        create: 'Crear',
        creating: 'Creando...',
        deleteConfirm: 'Confirmación de Eliminación',
        deleteMessage: '¿Estás seguro de que quieres eliminar la clave',
        deleteWarning: '? Esta acción no se puede deshacer.',
        delete: 'Eliminar',
        copied: 'Copiado al portapapeles',
        copyFailed: 'Error al copiar',
        createSuccess: 'Clave creada exitosamente',
        createFailed: 'Error al crear',
        deleteSuccess: 'Clave eliminada exitosamente',
        deleteFailed: 'Error al eliminar',
        pleaseEnterDesc: 'Por favor ingresa la descripción de la clave',

        // Página History
        historyTitle: 'Historial de Tareas',
        historyDesc: 'Monitorea el estado de tus llamadas API, latencia y costo.',
        searchId: 'Buscar ID',
        filter: 'Filtrar',
        allStatus: 'Todos los Estados',
        onlySuccess: 'Solo Exitosos',
        onlyFailed: 'Solo Fallidos',
        processing: 'Procesando',
        taskId: 'ID de Tarea',
        model: 'Modelo',
        status: 'Estado',
        latency: 'Latencia',
        cost: 'Costo',
        time: 'Tiempo',
        success: 'Exitoso',
        failed: 'Fallido',
        noRecords: 'No hay registros de historial',
        loadMore: 'Cargar Más',
        noMore: 'No hay más',
        requestId: 'ID de Solicitud',
        method: 'Método',
        operationType: 'Tipo',
        duration: 'Duración',
        costCredits: 'Costo (Créditos)',
        paginationText: 'Mostrando {from} a {to} de {total} registros',

        // Página Contact
        needHelp: '¿Necesitas Ayuda?',
        contactDesc:
            'Ya sea problemas de integración de API, personalización empresarial o aumentos de cuota, nuestro equipo técnico responderá en 24 horas.',
        techSupport: 'Correo de Soporte Técnico',
        supportTime:
            'Lun-Dom 09:00-23:00 (GMT+8). Los clientes empresariales pueden acceder al soporte VIP 7x24.',
        sendEmail: 'Enviar Correo',
        viewDocs: 'Ver Documentación',

        // Página Pricing
        pricingTitle: 'Precios y Facturación',
        pricingDesc: 'Modelo flexible de pago por uso, paga solo por lo que usas.',
        currentBalance: 'Saldo Actual',
        credits: 'Créditos',
        billingRecords: 'Registros de Facturación',
        buyCredits: 'Comprar Créditos',
        priceLabel: 'Precio',
        creditsLabel: 'Créditos',
        unitPrice: 'Precio Unitario',
        loading: 'Cargando...',
        buySelected: 'Comprar Paquete Seleccionado',
        modelRates: 'Tarifas de Uso de Modelos',
        modelLabel: 'Modelo',
        consumptionLabel: 'Consumo',
        weryPrice: 'Precio Wery',
        competitorA: 'Competidor A',
        competitorB: 'Competidor B',
    },
    fr: {
        // Navigation par onglets
        discovery: 'Découverte',
        discoveryH1: 'Explorez tous les API de modèles IA de vidéo et d\'image sur une seule plateforme',
        docs: 'Documents',
        apiKeys: 'Clés API',
        history: 'Historique',
        pricing: 'Tarification',
        contact: 'Contact',

        // SEO
        pageTitle: 'Documentation API - 微鲤AI',
        pageDescription:
            "Documentation de l'API 微鲤AI - Description complète de l'interface API et guide d'utilisation",

        // Page Discovery
        coreCapabilities: 'Capacités Principales',
        coreCapabilitiesDesc:
            'Explorez les capacités IA génératives de Wery AI',
        supportedModels: 'Modèles Supportés',
        supportedModelsDesc: 'Modèles vidéo et image de pointe intégrés',
        video: 'Vidéo',
        image: 'Image',

        // Cartes de capacités
        textToImage: 'Texte vers Image',
        textToImageDesc: 'Générer des images depuis du texte',
        imageToImage: 'Image vers Image',
        imageToImageDesc: 'Créer de nouvelles images depuis référence',
        textToVideo: 'Texte vers Vidéo',
        textToVideoDesc: 'Convertir du texte en vidéo',
        imageToVideo: 'Image vers Vidéo',
        imageToVideoDesc: 'Animer des images statiques',
        multiImageToVideo: 'Multi-Images vers Vidéo',
        multiImageToVideoDesc: 'Créer des vidéos depuis plusieurs images',
        podcast: 'Podcast IA',
        podcastDesc: "Générer de l'audio multi-personnages",
        music: 'Musique IA',
        musicDesc: 'Créer de la musique originale',
        digitalAvatar: 'Avatar IA',
        digitalAvatarDesc: "Générer des vidéos d'avatar synchronisées",

        // Page Docs
        docsPageTitle: 'Page Docs',
        docsPageDesc: 'Ceci est la page Docs pour la documentation API',

        // Page Keys
        keysTitle: 'Clés API',
        keysDesc: "Gérez vos clés d'accès API.",
        createNewKey: 'Créer une Nouvelle Clé',
        description: 'Description',
        secretKey: 'Clé Secrète',
        createTime: 'Créée',
        actions: 'Actions',
        noKeys: "Pas encore de clés API",
        createFirstKey: 'Créez votre première clé',
        createKeyTitle: 'Créer une Clé API',
        keyNameLabel: 'Nom de la Clé / Description',
        keyNamePlaceholder: 'ex. Application de Production',
        cancel: 'Annuler',
        create: 'Créer',
        creating: 'Création...',
        deleteConfirm: 'Confirmation de Suppression',
        deleteMessage: 'Êtes-vous sûr de vouloir supprimer la clé',
        deleteWarning: " ? Cette action ne peut pas être annulée.",
        delete: 'Supprimer',
        copied: 'Copié dans le presse-papiers',
        copyFailed: 'Échec de la copie',
        createSuccess: 'Clé créée avec succès',
        createFailed: 'Échec de la création',
        deleteSuccess: 'Clé supprimée avec succès',
        deleteFailed: 'Échec de la suppression',
        pleaseEnterDesc: 'Veuillez entrer la description de la clé',

        // Page History
        historyTitle: 'Historique des Tâches',
        historyDesc: "Surveillez l'état de vos appels API, la latence et le coût.",
        searchId: 'Rechercher ID',
        filter: 'Filtrer',
        allStatus: 'Tous les États',
        onlySuccess: 'Réussis Uniquement',
        onlyFailed: 'Échoués Uniquement',
        processing: 'En Traitement',
        taskId: 'ID de Tâche',
        model: 'Modèle',
        status: 'État',
        latency: 'Latence',
        cost: 'Coût',
        time: 'Temps',
        success: 'Réussi',
        failed: 'Échoué',
        noRecords: "Aucun enregistrement d'historique",
        loadMore: 'Charger Plus',
        noMore: 'Plus rien',
        requestId: 'ID de Requête',
        method: 'Méthode',
        operationType: 'Type',
        duration: 'Durée',
        costCredits: 'Coût (Crédits)',
        paginationText: 'Affichage de {from} à {to} sur {total} enregistrements',

        // Page Contact
        needHelp: "Besoin d'Aide ?",
        contactDesc:
            "Qu'il s'agisse de problèmes d'intégration API, de personnalisation d'entreprise ou d'augmentation de quota, notre équipe technique répondra dans les 24 heures.",
        techSupport: 'Email de Support Technique',
        supportTime:
            'Lun-Dim 09:00-23:00 (GMT+8). Les clients entreprise peuvent accéder au support VIP 7x24.',
        sendEmail: 'Envoyer un Email',
        viewDocs: 'Voir la Documentation',

        // Page Pricing
        pricingTitle: 'Tarification et Facturation',
        pricingDesc: 'Modèle flexible de paiement à l\'usage, payez uniquement ce que vous utilisez.',
        currentBalance: 'Solde Actuel',
        credits: 'Crédits',
        billingRecords: 'Enregistrements de Facturation',
        buyCredits: 'Acheter des Crédits',
        priceLabel: 'Prix',
        creditsLabel: 'Crédits',
        unitPrice: 'Prix Unitaire',
        loading: 'Chargement...',
        buySelected: 'Acheter le Forfait Sélectionné',
        modelRates: "Tarifs d'Utilisation des Modèles",
        modelLabel: 'Modèle',
        consumptionLabel: 'Consommation',
        weryPrice: 'Prix Wery',
        competitorA: 'Concurrent A',
        competitorB: 'Concurrent B',
    },
    de: {
        // Tab-Navigation
        discovery: 'Entdecken',
        discoveryH1: 'Entdecken Sie alle wichtigen AI Video- und Bildmodell-APIs auf einer Plattform',
        docs: 'Dokumentation',
        apiKeys: 'API-Schlüssel',
        history: 'Verlauf',
        pricing: 'Preise',
        contact: 'Kontakt',

        // SEO
        pageTitle: 'API-Dokumentation - 微鲤AI',
        pageDescription:
            '微鲤AI API-Dokumentation - Vollständige API-Schnittstellenbeschreibung und Nutzungsanleitung',

        // Discovery-Seite
        coreCapabilities: 'Kernfunktionen',
        coreCapabilitiesDesc: "Entdecke Wery AI's generative KI-Funktionen",
        supportedModels: 'Unterstützte Modelle',
        supportedModelsDesc:
            'Branchenführende Video- und Bildmodelle integriert',
        video: 'Video',
        image: 'Bild',

        // Funktionskarten
        textToImage: 'Text zu Bild',
        textToImageDesc: 'Bilder aus Text generieren',
        imageToImage: 'Bild zu Bild',
        imageToImageDesc: 'Neue Bilder aus Referenz erstellen',
        textToVideo: 'Text zu Video',
        textToVideoDesc: 'Text in Video umwandeln',
        imageToVideo: 'Bild zu Video',
        imageToVideoDesc: 'Statische Bilder animieren',
        multiImageToVideo: 'Multi-Bild zu Video',
        multiImageToVideoDesc: 'Videos aus mehreren Bildern erstellen',
        podcast: 'KI-Podcast',
        podcastDesc: 'Multi-Charakter-Audio generieren',
        music: 'KI-Musik',
        musicDesc: 'Originalmusik erstellen',
        digitalAvatar: 'KI-Avatar',
        digitalAvatarDesc: 'Synchronisierte Avatar-Videos generieren',

        // Docs-Seite
        docsPageTitle: 'Docs-Seite',
        docsPageDesc: 'Dies ist die Docs-Seite für API-Dokumentation',

        // Keys-Seite
        keysTitle: 'API-Schlüssel',
        keysDesc: 'Verwalten Sie Ihre API-Zugriffsschlüssel.',
        createNewKey: 'Neuen Schlüssel Erstellen',
        description: 'Beschreibung',
        secretKey: 'Geheimer Schlüssel',
        createTime: 'Erstellt',
        actions: 'Aktionen',
        noKeys: 'Noch keine API-Schlüssel',
        createFirstKey: 'Erstellen Sie Ihren ersten Schlüssel',
        createKeyTitle: 'API-Schlüssel Erstellen',
        keyNameLabel: 'Schlüsselname / Beschreibung',
        keyNamePlaceholder: 'z.B. Produktions-App',
        cancel: 'Abbrechen',
        create: 'Erstellen',
        creating: 'Erstelle...',
        deleteConfirm: 'Löschbestätigung',
        deleteMessage: 'Möchten Sie den Schlüssel wirklich löschen',
        deleteWarning: '? Diese Aktion kann nicht rückgängig gemacht werden.',
        delete: 'Löschen',
        copied: 'In Zwischenablage kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        createSuccess: 'Schlüssel erfolgreich erstellt',
        createFailed: 'Erstellung fehlgeschlagen',
        deleteSuccess: 'Schlüssel erfolgreich gelöscht',
        deleteFailed: 'Löschen fehlgeschlagen',
        pleaseEnterDesc: 'Bitte geben Sie eine Schlüsselbeschreibung ein',

        // History-Seite
        historyTitle: 'Aufgabenverlauf',
        historyDesc: 'Überwachen Sie den Status Ihrer API-Aufrufe, Latenz und Kosten.',
        searchId: 'ID Suchen',
        filter: 'Filtern',
        allStatus: 'Alle Status',
        onlySuccess: 'Nur Erfolgreich',
        onlyFailed: 'Nur Fehlgeschlagen',
        processing: 'Verarbeitung',
        taskId: 'Aufgaben-ID',
        model: 'Modell',
        status: 'Status',
        latency: 'Latenz',
        cost: 'Kosten',
        time: 'Zeit',
        success: 'Erfolgreich',
        failed: 'Fehlgeschlagen',
        noRecords: 'Keine Verlaufsdatensätze',
        loadMore: 'Mehr Laden',
        noMore: 'Keine weiteren',
        requestId: 'Anfrage-ID',
        method: 'Methode',
        operationType: 'Typ',
        duration: 'Dauer',
        costCredits: 'Kosten (Credits)',
        paginationText: 'Zeige {from} bis {to} von {total} Einträgen',

        // Contact-Seite
        needHelp: 'Brauchen Sie Hilfe?',
        contactDesc:
            'Ob API-Integrationsprobleme, Unternehmensanpassungen oder Quota-Erhöhungen, unser technisches Team wird innerhalb von 24 Stunden antworten.',
        techSupport: 'Technischer Support Email',
        supportTime:
            'Mo-So 09:00-23:00 (GMT+8). Unternehmenskunden können auf 7x24 VIP-Support zugreifen.',
        sendEmail: 'Email Senden',
        viewDocs: 'Dokumentation Ansehen',

        // Pricing-Seite
        pricingTitle: 'Preise und Abrechnung',
        pricingDesc: 'Flexibles Pay-as-you-go-Modell, zahlen Sie nur für das, was Sie nutzen.',
        currentBalance: 'Aktueller Saldo',
        credits: 'Credits',
        billingRecords: 'Abrechnungsaufzeichnungen',
        buyCredits: 'Credits Kaufen',
        priceLabel: 'Preis',
        creditsLabel: 'Credits',
        unitPrice: 'Stückpreis',
        loading: 'Lädt...',
        buySelected: 'Ausgewähltes Paket Kaufen',
        modelRates: 'Modellverbrauchsraten',
        modelLabel: 'Modell',
        consumptionLabel: 'Verbrauch',
        weryPrice: 'Wery Preis',
        competitorA: 'Konkurrent A',
        competitorB: 'Konkurrent B',
    },
    ru: {
        // Навигация по вкладкам
        discovery: 'Обзор',
        discoveryH1: 'Исследуйте все основные API-интерфейсы моделей ИИ для видео и изображений на одной платформе',
        docs: 'Документация',
        apiKeys: 'Ключи API',
        history: 'История',
        pricing: 'Цены',
        contact: 'Контакты',

        // SEO
        pageTitle: 'API Документация - 微鲤AI',
        pageDescription:
            'Документация API 微鲤AI - Полное описание интерфейса API и руководство по использованию',

        // Страница Discovery
        coreCapabilities: 'Основные возможности',
        coreCapabilitiesDesc: 'Изучите генеративные возможности ИИ Wery AI',
        supportedModels: 'Поддерживаемые модели',
        supportedModelsDesc: 'Ведущие видео и изображения модели интегрированы',
        video: 'Видео',
        image: 'Изображение',

        // Карточки возможностей
        textToImage: 'Текст в изображение',
        textToImageDesc: 'Генерация изображений из текста',
        imageToImage: 'Изображение в изображение',
        imageToImageDesc: 'Создание новых изображений из референса',
        textToVideo: 'Текст в видео',
        textToVideoDesc: 'Преобразование текста в видео',
        imageToVideo: 'Изображение в видео',
        imageToVideoDesc: 'Анимация статических изображений',
        multiImageToVideo: 'Мульти-изображение в видео',
        multiImageToVideoDesc: 'Создание видео из нескольких изображений',
        podcast: 'ИИ Подкаст',
        podcastDesc: 'Генерация многоперсонажного аудио',
        music: 'ИИ Музыка',
        musicDesc: 'Создание оригинальной музыки',
        digitalAvatar: 'ИИ Аватар',
        digitalAvatarDesc: 'Генерация синхронизированных видео аватаров',

        // Страница Docs
        docsPageTitle: 'Страница Docs',
        docsPageDesc: 'Это страница Docs для документации API',

        // Страница Keys
        keysTitle: 'Ключи API',
        keysDesc: 'Управляйте ключами доступа к API.',
        createNewKey: 'Создать Новый Ключ',
        description: 'Описание',
        secretKey: 'Секретный Ключ',
        createTime: 'Создан',
        actions: 'Действия',
        noKeys: 'Пока нет ключей API',
        createFirstKey: 'Создайте свой первый ключ',
        createKeyTitle: 'Создать Ключ API',
        keyNameLabel: 'Имя Ключа / Описание',
        keyNamePlaceholder: 'напр. Продакшн-приложение',
        cancel: 'Отмена',
        create: 'Создать',
        creating: 'Создание...',
        deleteConfirm: 'Подтверждение Удаления',
        deleteMessage: 'Вы уверены, что хотите удалить ключ',
        deleteWarning: '? Это действие нельзя отменить.',
        delete: 'Удалить',
        copied: 'Скопировано в буфер обмена',
        copyFailed: 'Не удалось скопировать',
        createSuccess: 'Ключ успешно создан',
        createFailed: 'Не удалось создать',
        deleteSuccess: 'Ключ успешно удален',
        deleteFailed: 'Не удалось удалить',
        pleaseEnterDesc: 'Пожалуйста, введите описание ключа',

        // Страница History
        historyTitle: 'История Задач',
        historyDesc: 'Отслеживайте статус вызовов API, задержку и стоимость.',
        searchId: 'Поиск ID',
        filter: 'Фильтр',
        allStatus: 'Все Статусы',
        onlySuccess: 'Только Успешные',
        onlyFailed: 'Только Неудачные',
        processing: 'Обработка',
        taskId: 'ID Задачи',
        model: 'Модель',
        status: 'Статус',
        latency: 'Задержка',
        cost: 'Стоимость',
        time: 'Время',
        success: 'Успешно',
        failed: 'Неудачно',
        noRecords: 'Нет записей истории',
        loadMore: 'Загрузить Больше',
        noMore: 'Больше нет',
        requestId: 'ID Запроса',
        method: 'Метод',
        operationType: 'Тип',
        duration: 'Длительность',
        costCredits: 'Стоимость (Кредиты)',
        paginationText: 'Показано с {from} по {to} из {total} записей',

        // Страница Contact
        needHelp: 'Нужна Помощь?',
        contactDesc:
            'Будь то проблемы интеграции API, корпоративная настройка или увеличение квоты, наша техническая команда ответит в течение 24 часов.',
        techSupport: 'Email Технической Поддержки',
        supportTime:
            'Пн-Вс 09:00-23:00 (GMT+8). Корпоративные клиенты могут получить доступ к VIP-поддержке 7x24.',
        sendEmail: 'Отправить Email',
        viewDocs: 'Посмотреть Документацию',

        // Страница Pricing
        pricingTitle: 'Цены и Выставление Счетов',
        pricingDesc: 'Гибкая модель оплаты по мере использования, платите только за то, что используете.',
        currentBalance: 'Текущий Баланс',
        credits: 'Кредиты',
        billingRecords: 'Записи Выставления Счетов',
        buyCredits: 'Купить Кредиты',
        priceLabel: 'Цена',
        creditsLabel: 'Кредиты',
        unitPrice: 'Цена за Единицу',
        loading: 'Загрузка...',
        buySelected: 'Купить Выбранный Пакет',
        modelRates: 'Тарифы Использования Моделей',
        modelLabel: 'Модель',
        consumptionLabel: 'Потребление',
        weryPrice: 'Цена Wery',
        competitorA: 'Конкурент A',
        competitorB: 'Конкурент B',
    },
    pt: {
        // Navegação de guias
        discovery: 'Descoberta',
        discoveryH1: 'Explore todas as principais APIs de modelos de IA de vídeo e imagem em uma única plataforma',
        docs: 'Documentos',
        apiKeys: 'Chaves API',
        history: 'Histórico',
        pricing: 'Preços',
        contact: 'Contato',

        // SEO
        pageTitle: 'Documentação da API - 微鲤AI',
        pageDescription:
            'Documentação da API 微鲤AI - Descrição completa da interface da API e guia de uso',

        // Página Discovery
        coreCapabilities: 'Capacidades Principais',
        coreCapabilitiesDesc:
            'Explore as capacidades de IA generativa da Wery AI',
        supportedModels: 'Modelos Suportados',
        supportedModelsDesc: 'Modelos líderes de vídeo e imagem integrados',
        video: 'Vídeo',
        image: 'Imagem',

        // Cartões de capacidades
        textToImage: 'Texto para Imagem',
        textToImageDesc: 'Gerar imagens a partir de texto',
        imageToImage: 'Imagem para Imagem',
        imageToImageDesc: 'Criar novas imagens a partir de referência',
        textToVideo: 'Texto para Vídeo',
        textToVideoDesc: 'Converter texto em vídeo',
        imageToVideo: 'Imagem para Vídeo',
        imageToVideoDesc: 'Animar imagens estáticas',
        multiImageToVideo: 'Multi-Imagem para Vídeo',
        multiImageToVideoDesc: 'Criar vídeos a partir de múltiplas imagens',
        podcast: 'Podcast IA',
        podcastDesc: 'Gerar áudio multi-personagem',
        music: 'Música IA',
        musicDesc: 'Criar música original',
        digitalAvatar: 'Avatar IA',
        digitalAvatarDesc: 'Gerar vídeos de avatar sincronizados',

        // Página Docs
        docsPageTitle: 'Página Docs',
        docsPageDesc: 'Esta é a página Docs para documentação da API',

        // Página Keys
        keysTitle: 'Chaves API',
        keysDesc: 'Gerencie suas chaves de acesso à API.',
        createNewKey: 'Criar Nova Chave',
        description: 'Descrição',
        secretKey: 'Chave Secreta',
        createTime: 'Criada',
        actions: 'Ações',
        noKeys: 'Ainda não há chaves API',
        createFirstKey: 'Crie sua primeira chave',
        createKeyTitle: 'Criar Chave API',
        keyNameLabel: 'Nome da Chave / Descrição',
        keyNamePlaceholder: 'ex. Aplicação de Produção',
        cancel: 'Cancelar',
        create: 'Criar',
        creating: 'Criando...',
        deleteConfirm: 'Confirmação de Exclusão',
        deleteMessage: 'Tem certeza de que deseja excluir a chave',
        deleteWarning: '? Esta ação não pode ser desfeita.',
        delete: 'Excluir',
        copied: 'Copiado para a área de transferência',
        copyFailed: 'Falha ao copiar',
        createSuccess: 'Chave criada com sucesso',
        createFailed: 'Falha na criação',
        deleteSuccess: 'Chave excluída com sucesso',
        deleteFailed: 'Falha na exclusão',
        pleaseEnterDesc: 'Por favor, insira a descrição da chave',

        // Página History
        historyTitle: 'Histórico de Tarefas',
        historyDesc: 'Monitore o status das suas chamadas API, latência e custo.',
        searchId: 'Pesquisar ID',
        filter: 'Filtrar',
        allStatus: 'Todos os Status',
        onlySuccess: 'Apenas Sucesso',
        onlyFailed: 'Apenas Falhas',
        processing: 'Processando',
        taskId: 'ID da Tarefa',
        model: 'Modelo',
        status: 'Status',
        latency: 'Latência',
        cost: 'Custo',
        time: 'Tempo',
        success: 'Sucesso',
        failed: 'Falha',
        noRecords: 'Sem registros de histórico',
        loadMore: 'Carregar Mais',
        noMore: 'Não há mais',
        requestId: 'ID da Solicitação',
        method: 'Método',
        operationType: 'Tipo',
        duration: 'Duração',
        costCredits: 'Custo (Créditos)',
        paginationText: 'Mostrando {from} a {to} de {total} registros',

        // Página Contact
        needHelp: 'Precisa de Ajuda?',
        contactDesc:
            'Seja problemas de integração de API, personalização empresarial ou aumentos de cota, nossa equipe técnica responderá em 24 horas.',
        techSupport: 'Email de Suporte Técnico',
        supportTime:
            'Seg-Dom 09:00-23:00 (GMT+8). Clientes empresariais podem acessar o suporte VIP 7x24.',
        sendEmail: 'Enviar Email',
        viewDocs: 'Ver Documentação',

        // Página Pricing
        pricingTitle: 'Preços e Faturamento',
        pricingDesc: 'Modelo flexível de pagamento conforme o uso, pague apenas pelo que usar.',
        currentBalance: 'Saldo Atual',
        credits: 'Créditos',
        billingRecords: 'Registros de Faturamento',
        buyCredits: 'Comprar Créditos',
        priceLabel: 'Preço',
        creditsLabel: 'Créditos',
        unitPrice: 'Preço Unitário',
        loading: 'Carregando...',
        buySelected: 'Comprar Pacote Selecionado',
        modelRates: 'Taxas de Uso de Modelos',
        modelLabel: 'Modelo',
        consumptionLabel: 'Consumo',
        weryPrice: 'Preço Wery',
        competitorA: 'Concorrente A',
        competitorB: 'Concorrente B',
    },
    it: {
        // Navigazione a schede
        discovery: 'Scoperta',
        discoveryH1: 'Esplora tutte le principali API dei modelli di IA video e immagine in un\'unica piattaforma',
        docs: 'Documenti',
        apiKeys: 'Chiavi API',
        history: 'Cronologia',
        pricing: 'Prezzi',
        contact: 'Contatto',

        // SEO
        pageTitle: 'Documentazione API - 微鲤AI',
        pageDescription:
            "Documentazione API 微鲤AI - Descrizione completa dell'interfaccia API e guida all'uso",

        // Pagina Discovery
        coreCapabilities: 'Capacità Principali',
        coreCapabilitiesDesc: 'Esplora le capacità IA generativa di Wery AI',
        supportedModels: 'Modelli Supportati',
        supportedModelsDesc: 'Modelli video e immagine leader integrati',
        video: 'Video',
        image: 'Immagine',

        // Schede capacità
        textToImage: 'Testo a Immagine',
        textToImageDesc: 'Genera immagini dal testo',
        imageToImage: 'Immagine a Immagine',
        imageToImageDesc: 'Crea nuove immagini da riferimento',
        textToVideo: 'Testo a Video',
        textToVideoDesc: 'Converti testo in video',
        imageToVideo: 'Immagine a Video',
        imageToVideoDesc: 'Anima immagini statiche',
        multiImageToVideo: 'Multi-Immagine a Video',
        multiImageToVideoDesc: 'Crea video da più immagini',
        podcast: 'Podcast IA',
        podcastDesc: 'Genera audio multi-personaggio',
        music: 'Musica IA',
        musicDesc: 'Crea musica originale',
        digitalAvatar: 'Avatar IA',
        digitalAvatarDesc: 'Genera video avatar sincronizzati',

        // Pagina Docs
        docsPageTitle: 'Pagina Docs',
        docsPageDesc: 'Questa è la pagina Docs per la documentazione API',

        // Pagina Keys
        keysTitle: 'Chiavi API',
        keysDesc: 'Gestisci le tue chiavi di accesso API.',
        createNewKey: 'Crea Nuova Chiave',
        description: 'Descrizione',
        secretKey: 'Chiave Segreta',
        createTime: 'Creata',
        actions: 'Azioni',
        noKeys: 'Nessuna chiave API ancora',
        createFirstKey: 'Crea la tua prima chiave',
        createKeyTitle: 'Crea Chiave API',
        keyNameLabel: 'Nome Chiave / Descrizione',
        keyNamePlaceholder: 'es. App di Produzione',
        cancel: 'Annulla',
        create: 'Crea',
        creating: 'Creazione...',
        deleteConfirm: 'Conferma Eliminazione',
        deleteMessage: 'Sei sicuro di voler eliminare la chiave',
        deleteWarning: '? Questa azione non può essere annullata.',
        delete: 'Elimina',
        copied: 'Copiato negli appunti',
        copyFailed: 'Copia fallita',
        createSuccess: 'Chiave creata con successo',
        createFailed: 'Creazione fallita',
        deleteSuccess: 'Chiave eliminata con successo',
        deleteFailed: 'Eliminazione fallita',
        pleaseEnterDesc: 'Inserisci la descrizione della chiave',

        // Pagina History
        historyTitle: 'Cronologia Attività',
        historyDesc: 'Monitora lo stato delle chiamate API, latenza e costi.',
        searchId: 'Cerca ID',
        filter: 'Filtra',
        allStatus: 'Tutti gli Stati',
        onlySuccess: 'Solo Successi',
        onlyFailed: 'Solo Falliti',
        processing: 'Elaborazione',
        taskId: 'ID Attività',
        model: 'Modello',
        status: 'Stato',
        latency: 'Latenza',
        cost: 'Costo',
        time: 'Tempo',
        success: 'Successo',
        failed: 'Fallito',
        noRecords: 'Nessun record di cronologia',
        loadMore: 'Carica Altro',
        noMore: 'Niente altro',
        requestId: 'ID Richiesta',
        method: 'Metodo',
        operationType: 'Tipo',
        duration: 'Durata',
        costCredits: 'Costo (Crediti)',
        paginationText: 'Mostrando da {from} a {to} di {total} record',

        // Pagina Contact
        needHelp: 'Hai Bisogno di Aiuto?',
        contactDesc:
            "Che si tratti di problemi di integrazione API, personalizzazione aziendale o aumenti di quota, il nostro team tecnico risponderà entro 24 ore.",
        techSupport: 'Email di Supporto Tecnico',
        supportTime:
            'Lun-Dom 09:00-23:00 (GMT+8). I clienti aziendali possono accedere al supporto VIP 7x24.',
        sendEmail: 'Invia Email',
        viewDocs: 'Visualizza Documentazione',

        // Pagina Pricing
        pricingTitle: 'Prezzi e Fatturazione',
        pricingDesc: 'Modello flessibile pay-as-you-go, paga solo quello che usi.',
        currentBalance: 'Saldo Attuale',
        credits: 'Crediti',
        billingRecords: 'Registri di Fatturazione',
        buyCredits: 'Acquista Crediti',
        priceLabel: 'Prezzo',
        creditsLabel: 'Crediti',
        unitPrice: 'Prezzo Unitario',
        loading: 'Caricamento...',
        buySelected: 'Acquista Pacchetto Selezionato',
        modelRates: 'Tariffe di Utilizzo Modelli',
        modelLabel: 'Modello',
        consumptionLabel: 'Consumo',
        weryPrice: 'Prezzo Wery',
        competitorA: 'Concorrente A',
        competitorB: 'Concorrente B',
    },
    ar: {
        // التنقل بين علامات التبويب
        discovery: 'اكتشاف',
        discoveryH1: 'استكشف جميع واجهات برمجة تطبيقات نماذج الفيديو والصور بالذكاء الاصطناعي في منصة واحدة',
        docs: 'المستندات',
        apiKeys: 'مفاتيح API',
        history: 'السجل',
        pricing: 'الأسعار',
        contact: 'اتصل',

        // SEO
        pageTitle: 'توثيق API - 微鲤AI',
        pageDescription:
            'توثيق 微鲤AI API - وصف كامل لواجهة API ودليل الاستخدام',

        // صفحة Discovery
        coreCapabilities: 'القدرات الأساسية',
        coreCapabilitiesDesc:
            'استكشف قدرات الذكاء الاصطناعي التوليدية من Wery AI',
        supportedModels: 'النماذج المدعومة',
        supportedModelsDesc: 'نماذج الفيديو والصور الرائدة متكاملة',
        video: 'فيديو',
        image: 'صورة',

        // بطاقات القدرات
        textToImage: 'نص إلى صورة',
        textToImageDesc: 'توليد الصور من النص',
        imageToImage: 'صورة إلى صورة',
        imageToImageDesc: 'إنشاء صور جديدة من مرجع',
        textToVideo: 'نص إلى فيديو',
        textToVideoDesc: 'تحويل النص إلى فيديو',
        imageToVideo: 'صورة إلى فيديو',
        imageToVideoDesc: 'تحريك الصور الثابتة',
        multiImageToVideo: 'صور متعددة إلى فيديو',
        multiImageToVideoDesc: 'إنشاء فيديو من صور متعددة',
        podcast: 'بودكاست ذكاء اصطناعي',
        podcastDesc: 'توليد صوت متعدد الشخصيات',
        music: 'موسيقى ذكاء اصطناعي',
        musicDesc: 'إنشاء موسيقى أصلية',
        digitalAvatar: 'أفاتار ذكاء اصطناعي',
        digitalAvatarDesc: 'توليد فيديو أفاتار متزامن',

        // صفحة Docs
        docsPageTitle: 'صفحة Docs',
        docsPageDesc: 'هذه هي صفحة Docs لتوثيق API',

        // صفحة Keys
        keysTitle: 'مفاتيح API',
        keysDesc: 'إدارة مفاتيح الوصول إلى API الخاصة بك.',
        createNewKey: 'إنشاء مفتاح جديد',
        description: 'الوصف',
        secretKey: 'المفتاح السري',
        createTime: 'تم الإنشاء',
        actions: 'الإجراءات',
        noKeys: 'لا توجد مفاتيح API حتى الآن',
        createFirstKey: 'إنشاء مفتاحك الأول',
        createKeyTitle: 'إنشاء مفتاح API',
        keyNameLabel: 'اسم المفتاح / الوصف',
        keyNamePlaceholder: 'مثال: تطبيق الإنتاج',
        cancel: 'إلغاء',
        create: 'إنشاء',
        creating: 'جاري الإنشاء...',
        deleteConfirm: 'تأكيد الحذف',
        deleteMessage: 'هل أنت متأكد من حذف المفتاح',
        deleteWarning: '؟ لا يمكن التراجع عن هذا الإجراء.',
        delete: 'حذف',
        copied: 'تم النسخ إلى الحافظة',
        copyFailed: 'فشل النسخ',
        createSuccess: 'تم إنشاء المفتاح بنجاح',
        createFailed: 'فشل الإنشاء',
        deleteSuccess: 'تم حذف المفتاح بنجاح',
        deleteFailed: 'فشل الحذف',
        pleaseEnterDesc: 'الرجاء إدخال وصف المفتاح',

        // صفحة History
        historyTitle: 'سجل المهام',
        historyDesc: 'راقب حالة استدعاءات API والتأخير والتكلفة.',
        searchId: 'بحث عن ID',
        filter: 'تصفية',
        allStatus: 'جميع الحالات',
        onlySuccess: 'الناجحة فقط',
        onlyFailed: 'الفاشلة فقط',
        processing: 'قيد المعالجة',
        taskId: 'معرف المهمة',
        model: 'النموذج',
        status: 'الحالة',
        latency: 'التأخير',
        cost: 'التكلفة',
        time: 'الوقت',
        success: 'نجح',
        failed: 'فشل',
        noRecords: 'لا توجد سجلات',
        loadMore: 'تحميل المزيد',
        noMore: 'لا يوجد المزيد',
        requestId: 'معرف الطلب',
        method: 'الطريقة',
        operationType: 'النوع',
        duration: 'المدة',
        costCredits: 'التكلفة (الأرصدة)',
        paginationText: 'عرض {from} إلى {to} من أصل {total} سجل',

        // صفحة Contact
        needHelp: 'تحتاج مساعدة؟',
        contactDesc:
            'سواء كانت مشاكل تكامل API أو التخصيص المؤسسي أو زيادة الحصة، سيرد فريقنا التقني خلال 24 ساعة.',
        techSupport: 'البريد الإلكتروني للدعم التقني',
        supportTime:
            'الإثنين-الأحد 09:00-23:00 (GMT+8). يمكن للعملاء من الشركات الوصول إلى دعم VIP على مدار الساعة طوال أيام الأسبوع.',
        sendEmail: 'إرسال بريد إلكتروني',
        viewDocs: 'عرض الوثائق',

        // صفحة Pricing
        pricingTitle: 'الأسعار والفوترة',
        pricingDesc: 'نموذج مرن للدفع حسب الاستخدام، ادفع فقط مقابل ما تستخدمه.',
        currentBalance: 'الرصيد الحالي',
        credits: 'الأرصدة',
        billingRecords: 'سجلات الفواتير',
        buyCredits: 'شراء أرصدة',
        priceLabel: 'السعر',
        creditsLabel: 'الأرصدة',
        unitPrice: 'سعر الوحدة',
        loading: 'جاري التحميل...',
        buySelected: 'شراء الباقة المحددة',
        modelRates: 'معدلات استخدام النموذج',
        modelLabel: 'النموذج',
        consumptionLabel: 'الاستهلاك',
        weryPrice: 'سعر Wery',
        competitorA: 'المنافس أ',
        competitorB: 'المنافس ب',
    },
    pl: {
        // Nawigacja zakładek
        discovery: 'Odkryj',
        discoveryH1: 'Poznaj wszystkie główne API modeli wideo i obrazu AI na jednej platformie',
        docs: 'Dokumentacja',
        apiKeys: 'Klucze API',
        history: 'Historia',
        pricing: 'Cennik',
        contact: 'Kontakt',

        // SEO
        pageTitle: 'Dokumentacja API - 微鲤AI',
        pageDescription:
            'Dokumentacja API 微鲤AI - Pełny opis interfejsu API i przewodnik użytkowania',

        // Strona Discovery
        coreCapabilities: 'Główne możliwości',
        coreCapabilitiesDesc: 'Poznaj pełen zakres możliwości generatywnej AI Wery AI',
        supportedModels: 'Wspierane modele',
        supportedModelsDesc: 'Wiodące w branży modele wideo i obrazu zintegrowane z platformą',
        video: 'Wideo',
        image: 'Obraz',

        // Karty możliwości
        textToImage: 'Tekst na obraz',
        textToImageDesc: 'Generuj wysokiej jakości obrazy z tekstu',
        imageToImage: 'Obraz na obraz',
        imageToImageDesc: 'Twórz nowe obrazy na podstawie referencji',
        textToVideo: 'Tekst na wideo',
        textToVideoDesc: 'Przekształć tekst w wideo',
        imageToVideo: 'Obraz na wideo',
        imageToVideoDesc: 'Ożyw statyczne obrazy',
        multiImageToVideo: 'Wiele obrazów na wideo',
        multiImageToVideoDesc: 'Twórz wideo z wielu obrazów',
        podcast: 'Podcast AI',
        podcastDesc: 'Generuj audio z wieloma postaciami',
        music: 'Muzyka AI',
        musicDesc: 'Twórz oryginalną muzykę',
        digitalAvatar: 'Awatar AI',
        digitalAvatarDesc: 'Generuj zsynchronizowane wideo awatara',

        // Strona Docs
        docsPageTitle: 'Strona dokumentacji',
        docsPageDesc: 'To jest strona dokumentacji API',

        // Strona Keys
        keysTitle: 'Klucze API',
        keysDesc: 'Zarządzaj kluczami dostępu do API.',
        createNewKey: 'Utwórz nowy klucz',
        description: 'Opis',
        secretKey: 'Tajny klucz',
        createTime: 'Data utworzenia',
        actions: 'Akcje',
        noKeys: 'Brak kluczy API',
        createFirstKey: 'Utwórz pierwszy klucz',
        createKeyTitle: 'Utwórz klucz API',
        keyNameLabel: 'Nazwa klucza / Opis',
        keyNamePlaceholder: 'np. Aplikacja produkcyjna',
        cancel: 'Anuluj',
        create: 'Utwórz',
        creating: 'Tworzenie...',
        deleteConfirm: 'Potwierdzenie usunięcia',
        deleteMessage: 'Czy na pewno chcesz usunąć klucz',
        deleteWarning: '? Ta operacja jest nieodwracalna.',
        delete: 'Usuń',
        copied: 'Skopiowano do schowka',
        copyFailed: 'Kopiowanie nie powiodło się',
        createSuccess: 'Klucz utworzony pomyślnie',
        createFailed: 'Tworzenie nie powiodło się',
        deleteSuccess: 'Klucz usunięty pomyślnie',
        deleteFailed: 'Usuwanie nie powiodło się',
        pleaseEnterDesc: 'Wprowadź opis klucza',

        // Strona History
        historyTitle: 'Historia zadań',
        historyDesc: 'Monitoruj status wywołań API, opóźnienia i koszty.',
        searchId: 'Szukaj ID',
        filter: 'Filtr',
        allStatus: 'Wszystkie statusy',
        onlySuccess: 'Tylko sukces',
        onlyFailed: 'Tylko błędy',
        processing: 'W trakcie',
        taskId: 'ID zadania',
        model: 'Model',
        status: 'Status',
        latency: 'Opóźnienie',
        cost: 'Koszt',
        time: 'Czas',
        success: 'Sukces',
        failed: 'Błąd',
        noRecords: 'Brak historii',
        loadMore: 'Załaduj więcej',
        noMore: 'Nie ma więcej',
        requestId: 'ID żądania',
        method: 'Metoda',
        operationType: 'Typ',
        duration: 'Czas trwania',
        costCredits: 'Koszt (Kredyty)',
        paginationText: 'Wyświetlanie {from} do {to} z {total} rekordów',

        // Strona Contact
        needHelp: 'Potrzebujesz pomocy?',
        contactDesc:
            'Czy to problemy z integracją API, potrzeby niestandardowe przedsiębiorstwa, czy zwiększenie limitu, nasz zespół techniczny odpowie w ciągu 24 godzin.',
        techSupport: 'Email wsparcia technicznego',
        supportTime:
            'Pon-Niedz 09:00-23:00 (GMT+8). Klienci korporacyjni mają dostęp do wsparcia 7x24 VIP.',
        sendEmail: 'Wyślij email',
        viewDocs: 'Zobacz dokumentację',

        // Strona Pricing
        pricingTitle: 'Cennik i rozliczenia',
        pricingDesc: 'Elastyczny model płatności za użycie.',
        currentBalance: 'Obecne saldo',
        credits: 'Kredyty',
        billingRecords: 'Historia rozliczeń',
        buyCredits: 'Kup kredyty',
        priceLabel: 'Cena',
        creditsLabel: 'Kredyty',
        unitPrice: 'Cena jednostkowa',
        loading: 'Ładowanie...',
        buySelected: 'Kup wybrany pakiet',
        modelRates: 'Stawki zużycia modelu',
        modelLabel: 'Model',
        consumptionLabel: 'Zużycie',
        weryPrice: 'Cena Wery',
        competitorA: 'Konkurent A',
        competitorB: 'Konkurent B',
    },
    tw: {
        // Tab 導航
        discovery: '發現',
        discoveryH1: '一站式探索所有主流 AI 影片與圖像生成模型 API',
        docs: '文檔',
        apiKeys: 'API 密鑰',
        history: '歷史',
        pricing: '價格',
        contact: '聯絡',

        // SEO
        pageTitle: 'API 文檔 - 微鲤AI',
        pageDescription: '微鲤AI API 文檔 - 提供完整的 API 接口說明和使用指南',

        // Discovery 頁面
        coreCapabilities: '核心能力',
        coreCapabilitiesDesc: '探索 Wery AI 提供的全方位生成式 AI 能力。',
        supportedModels: '支援模型',
        supportedModelsDesc: '平台整合的業界頂尖視訊與圖像模型。',
        video: '視訊',
        image: '圖像',

        // 能力卡片
        textToImage: '文生圖',
        textToImageDesc: '透過文字描述生成高品質圖片',
        imageToImage: '圖生圖',
        imageToImageDesc: '基於參考圖生成新的圖片',
        textToVideo: '文生影片',
        textToVideoDesc: '將文字腳本轉化為動態影片',
        imageToVideo: '圖生影片',
        imageToVideoDesc: '讓靜態圖片動起來',
        multiImageToVideo: '多圖生影片',
        multiImageToVideoDesc: '多張圖片生成連貫影片',
        podcast: 'AI 播客',
        podcastDesc: '生成多角色對話音訊',
        music: 'AI 音樂',
        musicDesc: '創作原創背景音樂',
        digitalAvatar: 'AI 數位人',
        digitalAvatarDesc: '生成口型同步的數位人影片',

        // Docs 頁面
        docsPageTitle: 'Docs 頁面',
        docsPageDesc: '這是 Docs 頁面,用於展示 API 文檔',

        // Keys 頁面
        keysTitle: 'API 密鑰',
        keysDesc: '管理您的 API 存取密鑰。',
        createNewKey: '建立新密鑰',
        description: '描述',
        secretKey: 'Secret Key',
        createTime: '建立時間',
        actions: '操作',
        noKeys: '暫無 API 密鑰',
        createFirstKey: '建立第一個密鑰',
        createKeyTitle: '建立 API Key',
        keyNameLabel: '密鑰名稱 / 描述',
        keyNamePlaceholder: '例如:生產環境應用',
        cancel: '取消',
        create: '建立',
        creating: '建立中...',
        deleteConfirm: '刪除確認',
        deleteMessage: '確定要刪除密鑰',
        deleteWarning: '嗎?此操作無法撤銷。',
        delete: '刪除',
        copied: '已複製到剪貼簿',
        copyFailed: '複製失敗',
        createSuccess: '密鑰建立成功',
        createFailed: '建立失敗',
        deleteSuccess: '密鑰刪除成功',
        deleteFailed: '刪除失敗',
        pleaseEnterDesc: '請輸入密鑰描述',

        // History 頁面
        historyTitle: '任務歷史',
        historyDesc: '監控您的 API 呼叫狀態、延遲和費用消耗。',
        searchId: '搜尋ID',
        filter: '篩選',
        allStatus: '全部狀態',
        onlySuccess: '僅顯示成功',
        onlyFailed: '僅顯示失敗',
        processing: '進行中',
        taskId: '任務 ID',
        model: '模型',
        status: '狀態',
        latency: '延遲',
        cost: '費用',
        time: '時間',
        success: '成功',
        failed: '失敗',
        noRecords: '暫無歷史記錄',
        loadMore: '載入更多',
        noMore: '沒有更多了',
        requestId: 'Request ID',
        method: '方法',
        operationType: '類型',
        duration: '耗時',
        costCredits: '費用 (積分)',
        paginationText: '顯示 {from} 到 {to} 條，共 {total} 條記錄',

        // Contact 頁面
        needHelp: '需要幫助?',
        contactDesc:
            '無論是 API 整合問題、企業定制需求,還是提升配額,我們的技術團隊都會在 24 小時內給予回應支援。',
        techSupport: '技術支援信箱',
        supportTime:
            '週一至週日 09:00-23:00 (GMT+8)。企業客戶可開通 7x24 小時 VIP 通道。',
        sendEmail: '發送郵件',
        viewDocs: '查看文檔',

        // Pricing 頁面
        pricingTitle: '價格與計費',
        pricingDesc: '靈活的按量付費模式,用多少付多少。',
        currentBalance: '當前金幣餘額',
        credits: '積分',
        billingRecords: '帳單記錄',
        buyCredits: '購買積分',
        priceLabel: '價格',
        creditsLabel: '積分',
        unitPrice: '單價',
        loading: '載入中...',
        buySelected: '購買選中套餐',
        modelRates: '模型消耗費率',
        modelLabel: '模型',
        consumptionLabel: '消耗',
        weryPrice: 'Wery 價格',
        competitorA: '競品 A',
        competitorB: '競品 B',
    },
    da: {
        // Fane navigation
        discovery: 'Opdagelse',
        discoveryH1: 'Udforsk alle større AI-video- og billedmodel-API\'er på én platform',
        docs: 'Dokumenter',
        apiKeys: 'API-nøgler',
        history: 'Historik',
        pricing: 'Priser',
        contact: 'Kontakt',

        // SEO
        pageTitle: 'API Dokumentation - 微鲤AI',
        pageDescription:
            '微鲤AI API Dokumentation - Komplet API grænsefladebeskrivelse og brugervejledning',

        // Discovery side
        coreCapabilities: 'Kernefunktioner',
        coreCapabilitiesDesc: 'Udforsk det fulde udvalg af generativ AI fra Wery AI',
        supportedModels: 'Understøttede modeller',
        supportedModelsDesc: 'Brancheførende video- og billedmodeller integreret',
        video: 'Video',
        image: 'Billede',

        // Funktionskort
        textToImage: 'Tekst til billede',
        textToImageDesc: 'Generer billeder fra tekst',
        imageToImage: 'Billede til billede',
        imageToImageDesc: 'Opret nye billeder fra reference',
        textToVideo: 'Tekst til video',
        textToVideoDesc: 'Konverter tekst til video',
        imageToVideo: 'Billede til video',
        imageToVideoDesc: 'Animér statiske billeder',
        multiImageToVideo: 'Flere billeder til video',
        multiImageToVideoDesc: 'Opret videoer fra flere billeder',
        podcast: 'AI Podcast',
        podcastDesc: 'Generer multi-karakter lyd',
        music: 'AI Musik',
        musicDesc: 'Skab original musik',
        digitalAvatar: 'AI Avatar',
        digitalAvatarDesc: 'Generer synkroniserede avatar-videoer',

        // Docs side
        docsPageTitle: 'Docs side',
        docsPageDesc: 'Dette er Docs-siden til API dokumentation',

        // Keys side
        keysTitle: 'API-nøgler',
        keysDesc: 'Administrer dine API-adgangsnøgler.',
        createNewKey: 'Opret ny nøgle',
        description: 'Beskrivelse',
        secretKey: 'Hemmelig nøgle',
        createTime: 'Oprettet',
        actions: 'Handlinger',
        noKeys: 'Ingen API-nøgler endnu',
        createFirstKey: 'Opret din første nøgle',
        createKeyTitle: 'Opret API-nøgle',
        keyNameLabel: 'Nøglenavn / Beskrivelse',
        keyNamePlaceholder: 'f.eks. Produktionsapp',
        cancel: 'Annuller',
        create: 'Opret',
        creating: 'Opretter...',
        deleteConfirm: 'Bekræft sletning',
        deleteMessage: 'Er du sikker på, at du vil slette nøgle',
        deleteWarning: '? Denne handling kan ikke fortrydes.',
        delete: 'Slet',
        copied: 'Kopieret til udklipsholder',
        copyFailed: 'Kopiering mislykkedes',
        createSuccess: 'Nøgle oprettet',
        createFailed: 'Oprettelse mislykkedes',
        deleteSuccess: 'Nøgle slettet',
        deleteFailed: 'Sletning mislykkedes',
        pleaseEnterDesc: 'Indtast venligst nøglebeskrivelse',

        // History side
        historyTitle: 'Opgavehistorik',
        historyDesc: 'Overvåg dine API-kaldsstatus, latens og omkostninger.',
        searchId: 'Søg ID',
        filter: 'Filter',
        allStatus: 'Alle statusser',
        onlySuccess: 'Kun succesfulde',
        onlyFailed: 'Kun mislykkede',
        processing: 'Behandler',
        taskId: 'Opgave-ID',
        model: 'Model',
        status: 'Status',
        latency: 'Latens',
        cost: 'Omkostning',
        time: 'Tid',
        success: 'Succes',
        failed: 'Mislykket',
        noRecords: 'Ingen historikoptegnelser',
        loadMore: 'Indlæs flere',
        noMore: 'Ikke flere',
        requestId: 'Anmodnings-ID',
        method: 'Metode',
        operationType: 'Type',
        duration: 'Varighed',
        costCredits: 'Omkostning (Credits)',
        paginationText: 'Viser {from} til {to} af {total} poster',

        // Contact side
        needHelp: 'Brug for hjælp?',
        contactDesc:
            'Uanset om det er API-integrationsproblemer, virksomhedstilpasning eller kvoteforøgelser, vil vores tekniske team svare inden for 24 timer.',
        techSupport: 'Teknisk support email',
        supportTime:
            'Man-Søn 09:00-23:00 (GMT+8). Virksomhedskunder kan få adgang til 7x24 VIP-support.',
        sendEmail: 'Send email',
        viewDocs: 'Se dokumentation',

        // Pricing side
        pricingTitle: 'Priser og fakturering',
        pricingDesc: 'Fleksibel betaling efter forbrug.',
        currentBalance: 'Nuværende saldo',
        credits: 'Credits',
        billingRecords: 'Faktureringsoptegnelser',
        buyCredits: 'Køb credits',
        priceLabel: 'Pris',
        creditsLabel: 'Credits',
        unitPrice: 'Enhedspris',
        loading: 'Indlæser...',
        buySelected: 'Køb valgt pakke',
        modelRates: 'Modelforbrugssatser',
        modelLabel: 'Model',
        consumptionLabel: 'Forbrug',
        weryPrice: 'Wery pris',
        competitorA: 'Konkurrent A',
        competitorB: 'Konkurrent B',
    },
    th: {
        // แท็บนำทาง
        discovery: 'ค้นพบ',
        discoveryH1: 'สำรวจ API โมเดลวิดีโอและภาพ AI หลักทั้งหมดในแพลตฟอร์มเดียว',
        docs: 'เอกสาร',
        apiKeys: 'คีย์ API',
        history: 'ประวัติ',
        pricing: 'ราคา',
        contact: 'ติดต่อ',

        // SEO
        pageTitle: 'เอกสาร API - 微鲤AI',
        pageDescription: 'เอกสาร API ของ 微鲤AI - คำอธิบาย API อินเทอร์เฟซและคู่มือการใช้งานที่สมบูรณ์',

        // หน้า Discovery
        coreCapabilities: 'ความสามารถหลัก',
        coreCapabilitiesDesc: 'สำรวจความสามารถ AI สร้างสรรค์แบบครบวงจรของ Wery AI',
        supportedModels: 'โมเดลที่รองรับ',
        supportedModelsDesc: 'โมเดลวิดีโอและภาพชั้นนำของอุตสาหกรรมที่ถูกรวมเข้าด้วยกัน',
        video: 'วิดีโอ',
        image: 'ภาพ',

        // การ์ดความสามารถ
        textToImage: 'ข้อความเป็นภาพ',
        textToImageDesc: 'สร้างภาพคุณภาพสูงจากข้อความ',
        imageToImage: 'ภาพเป็นภาพ',
        imageToImageDesc: 'สร้างภาพใหม่จากภาพอ้างอิง',
        textToVideo: 'ข้อความเป็นวิดีโอ',
        textToVideoDesc: 'แปลงข้อความเป็นวิดีโอ',
        imageToVideo: 'ภาพเป็นวิดีโอ',
        imageToVideoDesc: 'ทำให้ภาพนิ่งมีชีวิต',
        multiImageToVideo: 'หลายภาพเป็นวิดีโอ',
        multiImageToVideoDesc: 'สร้างวิดีโอจากภาพหลายภาพ',
        podcast: 'พอดแคสต์ AI',
        podcastDesc: 'สร้างเสียงบทสนทนาหลายตัวละคร',
        music: 'เพลง AI',
        musicDesc: 'สร้างเพลงต้นฉบับ',
        digitalAvatar: 'อวตาร AI',
        digitalAvatarDesc: 'สร้างวิดีโออวตารที่ซิงค์ริมฝีปาก',

        // หน้า Docs
        docsPageTitle: 'หน้า Docs',
        docsPageDesc: 'นี่คือหน้า Docs สำหรับเอกสาร API',

        // หน้า Keys
        keysTitle: 'คีย์ API',
        keysDesc: 'จัดการคีย์การเข้าถึง API ของคุณ',
        createNewKey: 'สร้างคีย์ใหม่',
        description: 'คำอธิบาย',
        secretKey: 'คีย์ลับ',
        createTime: 'สร้างเมื่อ',
        actions: 'การดำเนินการ',
        noKeys: 'ยังไม่มีคีย์ API',
        createFirstKey: 'สร้างคีย์แรกของคุณ',
        createKeyTitle: 'สร้างคีย์ API',
        keyNameLabel: 'ชื่อคีย์ / คำอธิบาย',
        keyNamePlaceholder: 'เช่น แอปพลิเคชันในการผลิต',
        cancel: 'ยกเลิก',
        create: 'สร้าง',
        creating: 'กำลังสร้าง...',
        deleteConfirm: 'ยืนยันการลบ',
        deleteMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบคีย์',
        deleteWarning: '? การดำเนินการนี้ไม่สามารถยกเลิกได้',
        delete: 'ลบ',
        copied: 'คัดลอกไปยังคลิปบอร์ดแล้ว',
        copyFailed: 'การคัดลอกล้มเหลว',
        createSuccess: 'สร้างคีย์สำเร็จ',
        createFailed: 'การสร้างล้มเหลว',
        deleteSuccess: 'ลบคีย์สำเร็จ',
        deleteFailed: 'การลบล้มเหลว',
        pleaseEnterDesc: 'กรุณาใส่คำอธิบายคีย์',

        // หน้า History
        historyTitle: 'ประวัติงาน',
        historyDesc: 'ตรวจสอบสถานะการเรียก API ความหน่วงเวลา และค่าใช้จ่าย',
        searchId: 'ค้นหา ID',
        filter: 'กรอง',
        allStatus: 'สถานะทั้งหมด',
        onlySuccess: 'เฉพาะสำเร็จ',
        onlyFailed: 'เฉพาะล้มเหลว',
        processing: 'กำลังดำเนินการ',
        taskId: 'ID งาน',
        model: 'โมเดล',
        status: 'สถานะ',
        latency: 'ความหน่วง',
        cost: 'ค่าใช้จ่าย',
        time: 'เวลา',
        success: 'สำเร็จ',
        failed: 'ล้มเหลว',
        noRecords: 'ไม่มีบันทึกประวัติ',
        loadMore: 'โหลดเพิ่มเติม',
        noMore: 'ไม่มีเพิ่มเติม',
        requestId: 'ID คำขอ',
        method: 'วิธีการ',
        operationType: 'ประเภท',
        duration: 'ระยะเวลา',
        costCredits: 'ค่าใช้จ่าย (เครดิต)',
        paginationText: 'แสดง {from} ถึง {to} จาก {total} รายการ',

        // หน้า Contact
        needHelp: 'ต้องการความช่วยเหลือ?',
        contactDesc:
            'ไม่ว่าจะเป็นปัญหาการรวม API ความต้องการปรับแต่งสำหรับองค์กร หรือการเพิ่มโควต้า ทีมเทคนิคของเราจะตอบกลับภายใน 24 ชั่วโมง',
        techSupport: 'อีเมลสนับสนุนทางเทคนิค',
        supportTime:
            'จันทร์-อาทิตย์ 09:00-23:00 (GMT+8) ลูกค้าองค์กรสามารถเข้าถึงการสนับสนุน VIP ตลอด 24 ชั่วโมง',
        sendEmail: 'ส่งอีเมล',
        viewDocs: 'ดูเอกสาร',

        // หน้า Pricing
        pricingTitle: 'ราคาและการเรียกเก็บเงิน',
        pricingDesc: 'โมเดลแบบจ่ายตามการใช้งานที่ยืดหยุ่น',
        currentBalance: 'ยอดคงเหลือปัจจุบัน',
        credits: 'เครดิต',
        billingRecords: 'บันทึกการเรียกเก็บเงิน',
        buyCredits: 'ซื้อเครดิต',
        priceLabel: 'ราคา',
        creditsLabel: 'เครดิต',
        unitPrice: 'ราคาต่อหน่วย',
        loading: 'กำลังโหลด...',
        buySelected: 'ซื้อแพ็คเกจที่เลือก',
        modelRates: 'อัตราการใช้โมเดล',
        modelLabel: 'โมเดล',
        consumptionLabel: 'การใช้งาน',
        weryPrice: 'ราคา Wery',
        competitorA: 'คู่แข่ง A',
        competitorB: 'คู่แข่ง B',
    },
    no: {
        // Fane navigasjon
        discovery: 'Oppdagelse',
        discoveryH1: 'Utforsk alle store API-er for AI-video- og bildemodeller på én plattform',
        docs: 'Dokumenter',
        apiKeys: 'API-nøkler',
        history: 'Historikk',
        pricing: 'Priser',
        contact: 'Kontakt',

        // SEO
        pageTitle: 'API Dokumentasjon - 微鲤AI',
        pageDescription:
            '微鲤AI API Dokumentasjon - Komplett API grensesnittbeskrivelse og brukerveiledning',

        // Discovery side
        coreCapabilities: 'Kjernefunksjoner',
        coreCapabilitiesDesc: 'Utforsk hele spekteret av generativ AI fra Wery AI',
        supportedModels: 'Støttede modeller',
        supportedModelsDesc: 'Bransjeledende video- og bildemodeller integrert',
        video: 'Video',
        image: 'Bilde',

        // Funksjonskort
        textToImage: 'Tekst til bilde',
        textToImageDesc: 'Generer bilder fra tekst',
        imageToImage: 'Bilde til bilde',
        imageToImageDesc: 'Lag nye bilder fra referanse',
        textToVideo: 'Tekst til video',
        textToVideoDesc: 'Konverter tekst til video',
        imageToVideo: 'Bilde til video',
        imageToVideoDesc: 'Animer statiske bilder',
        multiImageToVideo: 'Flere bilder til video',
        multiImageToVideoDesc: 'Lag videoer fra flere bilder',
        podcast: 'AI Podcast',
        podcastDesc: 'Generer flerkarakter lyd',
        music: 'AI Musikk',
        musicDesc: 'Lag original musikk',
        digitalAvatar: 'AI Avatar',
        digitalAvatarDesc: 'Generer synkroniserte avatar-videoer',

        // Docs side
        docsPageTitle: 'Docs side',
        docsPageDesc: 'Dette er Docs-siden for API dokumentasjon',

        // Keys side
        keysTitle: 'API-nøkler',
        keysDesc: 'Administrer dine API-tilgangsnøkler.',
        createNewKey: 'Opprett ny nøkkel',
        description: 'Beskrivelse',
        secretKey: 'Hemmelig nøkkel',
        createTime: 'Opprettet',
        actions: 'Handlinger',
        noKeys: 'Ingen API-nøkler ennå',
        createFirstKey: 'Opprett din første nøkkel',
        createKeyTitle: 'Opprett API-nøkkel',
        keyNameLabel: 'Nøkkelnavn / Beskrivelse',
        keyNamePlaceholder: 'f.eks. Produksjonsapp',
        cancel: 'Avbryt',
        create: 'Opprett',
        creating: 'Oppretter...',
        deleteConfirm: 'Bekreft sletting',
        deleteMessage: 'Er du sikker på at du vil slette nøkkel',
        deleteWarning: '? Denne handlingen kan ikke angres.',
        delete: 'Slett',
        copied: 'Kopiert til utklippstavle',
        copyFailed: 'Kopiering mislyktes',
        createSuccess: 'Nøkkel opprettet',
        createFailed: 'Oppretting mislyktes',
        deleteSuccess: 'Nøkkel slettet',
        deleteFailed: 'Sletting mislyktes',
        pleaseEnterDesc: 'Vennligst skriv inn nøkkelbeskrivelse',

        // History side
        historyTitle: 'Oppgavehistorikk',
        historyDesc: 'Overvåk dine API-kallstatus, latens og kostnader.',
        searchId: 'Søk ID',
        filter: 'Filter',
        allStatus: 'Alle statuser',
        onlySuccess: 'Kun vellykkede',
        onlyFailed: 'Kun mislykkede',
        processing: 'Behandler',
        taskId: 'Oppgave-ID',
        model: 'Modell',
        status: 'Status',
        latency: 'Latens',
        cost: 'Kostnad',
        time: 'Tid',
        success: 'Vellykket',
        failed: 'Mislyktes',
        noRecords: 'Ingen historikkposter',
        loadMore: 'Last mer',
        noMore: 'Ikke mer',
        requestId: 'Forespørsels-ID',
        method: 'Metode',
        operationType: 'Type',
        duration: 'Varighet',
        costCredits: 'Kostnad (Kreditter)',
        paginationText: 'Viser {from} til {to} av {total} poster',

        // Contact side
        needHelp: 'Trenger du hjelp?',
        contactDesc:
            'Enten det er API-integrasjonsproblemer, bedriftstilpasning eller kvoteøkninger, vil vårt tekniske team svare innen 24 timer.',
        techSupport: 'Teknisk support e-post',
        supportTime:
            'Man-Søn 09:00-23:00 (GMT+8). Bedriftskunder kan få tilgang til 7x24 VIP-støtte.',
        sendEmail: 'Send e-post',
        viewDocs: 'Se dokumentasjon',

        // Pricing side
        pricingTitle: 'Priser og fakturering',
        pricingDesc: 'Fleksibel betal-etter-bruk modell.',
        currentBalance: 'Nåværende saldo',
        credits: 'Kreditter',
        billingRecords: 'Faktureringsposter',
        buyCredits: 'Kjøp kreditter',
        priceLabel: 'Pris',
        creditsLabel: 'Kreditter',
        unitPrice: 'Enhetspris',
        loading: 'Laster...',
        buySelected: 'Kjøp valgt pakke',
        modelRates: 'Modellforbrukssatser',
        modelLabel: 'Modell',
        consumptionLabel: 'Forbruk',
        weryPrice: 'Wery pris',
        competitorA: 'Konkurrent A',
        competitorB: 'Konkurrent B',
    },
    nl: {
        // Tabblad navigatie
        discovery: 'Ontdekking',
        discoveryH1: 'Ontdek alle belangrijke AI video- en beeldmodel API\'s op één platform',
        docs: 'Documenten',
        apiKeys: 'API-sleutels',
        history: 'Geschiedenis',
        pricing: 'Prijzen',
        contact: 'Contact',

        // SEO
        pageTitle: 'API Documentatie - 微鲤AI',
        pageDescription:
            '微鲤AI API Documentatie - Volledige API interface beschrijving en gebruikshandleiding',

        // Discovery pagina
        coreCapabilities: 'Kernfuncties',
        coreCapabilitiesDesc: 'Ontdek het volledige scala aan generatieve AI van Wery AI',
        supportedModels: 'Ondersteunde modellen',
        supportedModelsDesc: 'Toonaangevende video- en beeldmodellen geïntegreerd',
        video: 'Video',
        image: 'Afbeelding',

        // Functiekaarten
        textToImage: 'Tekst naar afbeelding',
        textToImageDesc: 'Genereer afbeeldingen uit tekst',
        imageToImage: 'Afbeelding naar afbeelding',
        imageToImageDesc: 'Maak nieuwe afbeeldingen van referentie',
        textToVideo: 'Tekst naar video',
        textToVideoDesc: 'Converteer tekst naar video',
        imageToVideo: 'Afbeelding naar video',
        imageToVideoDesc: 'Animeer statische afbeeldingen',
        multiImageToVideo: 'Meerdere afbeeldingen naar video',
        multiImageToVideoDesc: 'Maak video\'s van meerdere afbeeldingen',
        podcast: 'AI Podcast',
        podcastDesc: 'Genereer multi-karakter audio',
        music: 'AI Muziek',
        musicDesc: 'Creëer originele muziek',
        digitalAvatar: 'AI Avatar',
        digitalAvatarDesc: 'Genereer gesynchroniseerde avatar-video\'s',

        // Docs pagina
        docsPageTitle: 'Docs pagina',
        docsPageDesc: 'Dit is de Docs-pagina voor API documentatie',

        // Keys pagina
        keysTitle: 'API-sleutels',
        keysDesc: 'Beheer uw API-toegangssleutels.',
        createNewKey: 'Nieuwe sleutel maken',
        description: 'Beschrijving',
        secretKey: 'Geheime sleutel',
        createTime: 'Aangemaakt',
        actions: 'Acties',
        noKeys: 'Nog geen API-sleutels',
        createFirstKey: 'Maak uw eerste sleutel',
        createKeyTitle: 'API-sleutel maken',
        keyNameLabel: 'Sleutelnaam / Beschrijving',
        keyNamePlaceholder: 'bijv. Productie-app',
        cancel: 'Annuleren',
        create: 'Maken',
        creating: 'Bezig met maken...',
        deleteConfirm: 'Bevestig verwijdering',
        deleteMessage: 'Weet u zeker dat u de sleutel wilt verwijderen',
        deleteWarning: '? Deze actie kan niet ongedaan worden gemaakt.',
        delete: 'Verwijderen',
        copied: 'Gekopieerd naar klembord',
        copyFailed: 'Kopiëren mislukt',
        createSuccess: 'Sleutel succesvol aangemaakt',
        createFailed: 'Aanmaken mislukt',
        deleteSuccess: 'Sleutel succesvol verwijderd',
        deleteFailed: 'Verwijderen mislukt',
        pleaseEnterDesc: 'Voer een sleutelbeschrijving in',

        // History pagina
        historyTitle: 'Taakgeschiedenis',
        historyDesc: 'Monitor uw API-oproepstatus, latentie en kosten.',
        searchId: 'Zoek ID',
        filter: 'Filter',
        allStatus: 'Alle statussen',
        onlySuccess: 'Alleen geslaagd',
        onlyFailed: 'Alleen mislukt',
        processing: 'Bezig met verwerken',
        taskId: 'Taak-ID',
        model: 'Model',
        status: 'Status',
        latency: 'Latentie',
        cost: 'Kosten',
        time: 'Tijd',
        success: 'Geslaagd',
        failed: 'Mislukt',
        noRecords: 'Geen geschiedenisrecords',
        loadMore: 'Meer laden',
        noMore: 'Niet meer',
        requestId: 'Verzoek-ID',
        method: 'Methode',
        operationType: 'Type',
        duration: 'Duur',
        costCredits: 'Kosten (Credits)',
        paginationText: 'Weergave {from} tot {to} van {total} records',

        // Contact pagina
        needHelp: 'Hulp nodig?',
        contactDesc:
            'Of het nu gaat om API-integratieproblemen, bedrijfsaanpassingen of quotaverhogingen, ons technische team reageert binnen 24 uur.',
        techSupport: 'Technische support e-mail',
        supportTime:
            'Ma-Zo 09:00-23:00 (GMT+8). Zakelijke klanten hebben toegang tot 7x24 VIP-ondersteuning.',
        sendEmail: 'E-mail verzenden',
        viewDocs: 'Documentatie bekijken',

        // Pricing pagina
        pricingTitle: 'Prijzen en facturering',
        pricingDesc: 'Flexibel pay-as-you-go model.',
        currentBalance: 'Huidig saldo',
        credits: 'Credits',
        billingRecords: 'Factureringsrecords',
        buyCredits: 'Credits kopen',
        priceLabel: 'Prijs',
        creditsLabel: 'Credits',
        unitPrice: 'Eenheidsprijs',
        loading: 'Laden...',
        buySelected: 'Geselecteerd pakket kopen',
        modelRates: 'Modelverbruikstarieven',
        modelLabel: 'Model',
        consumptionLabel: 'Verbruik',
        weryPrice: 'Wery prijs',
        competitorA: 'Concurrent A',
        competitorB: 'Concurrent B',
    },
    id: {
        // Navigasi tab
        discovery: 'Penemuan',
        discoveryH1: 'Jelajahi semua API model video dan gambar AI utama dalam satu platform',
        docs: 'Dokumen',
        apiKeys: 'Kunci API',
        history: 'Riwayat',
        pricing: 'Harga',
        contact: 'Kontak',

        // SEO
        pageTitle: 'Dokumentasi API - 微鲤AI',
        pageDescription:
            'Dokumentasi API 微鲤AI - Deskripsi antarmuka API lengkap dan panduan penggunaan',

        // Halaman Discovery
        coreCapabilities: 'Kemampuan Inti',
        coreCapabilitiesDesc: 'Jelajahi berbagai kemampuan AI generatif dari Wery AI',
        supportedModels: 'Model yang Didukung',
        supportedModelsDesc: 'Model video dan gambar terkemuka industri terintegrasi',
        video: 'Video',
        image: 'Gambar',

        // Kartu kemampuan
        textToImage: 'Teks ke Gambar',
        textToImageDesc: 'Hasilkan gambar dari teks',
        imageToImage: 'Gambar ke Gambar',
        imageToImageDesc: 'Buat gambar baru dari referensi',
        textToVideo: 'Teks ke Video',
        textToVideoDesc: 'Konversi teks ke video',
        imageToVideo: 'Gambar ke Video',
        imageToVideoDesc: 'Animasikan gambar statis',
        multiImageToVideo: 'Multi-Gambar ke Video',
        multiImageToVideoDesc: 'Buat video dari beberapa gambar',
        podcast: 'Podcast AI',
        podcastDesc: 'Hasilkan audio multi-karakter',
        music: 'Musik AI',
        musicDesc: 'Buat musik original',
        digitalAvatar: 'Avatar AI',
        digitalAvatarDesc: 'Hasilkan video avatar tersinkronisasi',

        // Halaman Docs
        docsPageTitle: 'Halaman Docs',
        docsPageDesc: 'Ini adalah halaman Docs untuk dokumentasi API',

        // Halaman Keys
        keysTitle: 'Kunci API',
        keysDesc: 'Kelola kunci akses API Anda.',
        createNewKey: 'Buat Kunci Baru',
        description: 'Deskripsi',
        secretKey: 'Kunci Rahasia',
        createTime: 'Dibuat',
        actions: 'Tindakan',
        noKeys: 'Belum ada kunci API',
        createFirstKey: 'Buat kunci pertama Anda',
        createKeyTitle: 'Buat Kunci API',
        keyNameLabel: 'Nama Kunci / Deskripsi',
        keyNamePlaceholder: 'misal. Aplikasi Produksi',
        cancel: 'Batal',
        create: 'Buat',
        creating: 'Membuat...',
        deleteConfirm: 'Konfirmasi Penghapusan',
        deleteMessage: 'Apakah Anda yakin ingin menghapus kunci',
        deleteWarning: '? Tindakan ini tidak dapat dibatalkan.',
        delete: 'Hapus',
        copied: 'Disalin ke clipboard',
        copyFailed: 'Penyalinan gagal',
        createSuccess: 'Kunci berhasil dibuat',
        createFailed: 'Pembuatan gagal',
        deleteSuccess: 'Kunci berhasil dihapus',
        deleteFailed: 'Penghapusan gagal',
        pleaseEnterDesc: 'Silakan masukkan deskripsi kunci',

        // Halaman History
        historyTitle: 'Riwayat Tugas',
        historyDesc: 'Pantau status panggilan API, latensi, dan biaya Anda.',
        searchId: 'Cari ID',
        filter: 'Filter',
        allStatus: 'Semua Status',
        onlySuccess: 'Hanya Berhasil',
        onlyFailed: 'Hanya Gagal',
        processing: 'Memproses',
        taskId: 'ID Tugas',
        model: 'Model',
        status: 'Status',
        latency: 'Latensi',
        cost: 'Biaya',
        time: 'Waktu',
        success: 'Berhasil',
        failed: 'Gagal',
        noRecords: 'Tidak ada catatan riwayat',
        loadMore: 'Muat Lebih Banyak',
        noMore: 'Tidak ada lagi',
        requestId: 'ID Permintaan',
        method: 'Metode',
        operationType: 'Jenis',
        duration: 'Durasi',
        costCredits: 'Biaya (Kredit)',
        paginationText: 'Menampilkan {from} sampai {to} dari {total} catatan',

        // Halaman Contact
        needHelp: 'Butuh Bantuan?',
        contactDesc:
            'Baik itu masalah integrasi API, kebutuhan kustomisasi perusahaan, atau peningkatan kuota, tim teknis kami akan merespons dalam 24 jam.',
        techSupport: 'Email Dukungan Teknis',
        supportTime:
            'Sen-Min 09:00-23:00 (GMT+8). Pelanggan perusahaan dapat mengakses dukungan VIP 7x24.',
        sendEmail: 'Kirim Email',
        viewDocs: 'Lihat Dokumentasi',

        // Halaman Pricing
        pricingTitle: 'Harga & Penagihan',
        pricingDesc: 'Model bayar sesuai penggunaan yang fleksibel.',
        currentBalance: 'Saldo Saat Ini',
        credits: 'Kredit',
        billingRecords: 'Catatan Penagihan',
        buyCredits: 'Beli Kredit',
        priceLabel: 'Harga',
        creditsLabel: 'Kredit',
        unitPrice: 'Harga Satuan',
        loading: 'Memuat...',
        buySelected: 'Beli Paket Terpilih',
        modelRates: 'Tarif Penggunaan Model',
        modelLabel: 'Model',
        consumptionLabel: 'Konsumsi',
        weryPrice: 'Harga Wery',
        competitorA: 'Pesaing A',
        competitorB: 'Pesaing B',
    },
    tr: {
        // Sekme gezintisi
        discovery: 'Keşif',
        discoveryH1: 'Tüm önemli AI video ve görüntü modeli API\'lerini tek bir platformda keşfedin',
        docs: 'Belgeler',
        apiKeys: 'API Anahtarları',
        history: 'Geçmiş',
        pricing: 'Fiyatlandırma',
        contact: 'İletişim',

        // SEO
        pageTitle: 'API Dokümantasyonu - 微鲤AI',
        pageDescription:
            '微鲤AI API Dokümantasyonu - Tam API arayüz açıklaması ve kullanım kılavuzu',

        // Discovery sayfası
        coreCapabilities: 'Temel Yetenekler',
        coreCapabilitiesDesc: 'Wery AI\'ın tüm üretken AI yeteneklerini keşfedin',
        supportedModels: 'Desteklenen Modeller',
        supportedModelsDesc: 'Entegre edilmiş sektör lideri video ve görüntü modelleri',
        video: 'Video',
        image: 'Görüntü',

        // Yetenek kartları
        textToImage: 'Metinden Görüntü',
        textToImageDesc: 'Metinden görüntü oluşturun',
        imageToImage: 'Görüntüden Görüntü',
        imageToImageDesc: 'Referanstan yeni görüntüler oluşturun',
        textToVideo: 'Metinden Video',
        textToVideoDesc: 'Metni videoya dönüştürün',
        imageToVideo: 'Görüntüden Video',
        imageToVideoDesc: 'Sabit görüntüleri canlandırın',
        multiImageToVideo: 'Çoklu Görüntüden Video',
        multiImageToVideoDesc: 'Birden fazla görüntüden video oluşturun',
        podcast: 'AI Podcast',
        podcastDesc: 'Çok karakterli ses oluşturun',
        music: 'AI Müzik',
        musicDesc: 'Orijinal müzik yaratın',
        digitalAvatar: 'AI Avatar',
        digitalAvatarDesc: 'Senkronize avatar videoları oluşturun',

        // Docs sayfası
        docsPageTitle: 'Docs sayfası',
        docsPageDesc: 'Bu, API dokümantasyonu için Docs sayfasıdır',

        // Keys sayfası
        keysTitle: 'API Anahtarları',
        keysDesc: 'API erişim anahtarlarınızı yönetin.',
        createNewKey: 'Yeni Anahtar Oluştur',
        description: 'Açıklama',
        secretKey: 'Gizli Anahtar',
        createTime: 'Oluşturuldu',
        actions: 'İşlemler',
        noKeys: 'Henüz API anahtarı yok',
        createFirstKey: 'İlk anahtarınızı oluşturun',
        createKeyTitle: 'API Anahtarı Oluştur',
        keyNameLabel: 'Anahtar Adı / Açıklama',
        keyNamePlaceholder: 'örn. Üretim Uygulaması',
        cancel: 'İptal',
        create: 'Oluştur',
        creating: 'Oluşturuluyor...',
        deleteConfirm: 'Silme Onayı',
        deleteMessage: 'Anahtarı silmek istediğinizden emin misiniz',
        deleteWarning: '? Bu işlem geri alınamaz.',
        delete: 'Sil',
        copied: 'Panoya kopyalandı',
        copyFailed: 'Kopyalama başarısız',
        createSuccess: 'Anahtar başarıyla oluşturuldu',
        createFailed: 'Oluşturma başarısız',
        deleteSuccess: 'Anahtar başarıyla silindi',
        deleteFailed: 'Silme başarısız',
        pleaseEnterDesc: 'Lütfen anahtar açıklaması girin',

        // History sayfası
        historyTitle: 'Görev Geçmişi',
        historyDesc: 'API çağrı durumunuzu, gecikmenizi ve maliyetinizi izleyin.',
        searchId: 'ID Ara',
        filter: 'Filtre',
        allStatus: 'Tüm Durumlar',
        onlySuccess: 'Sadece Başarılı',
        onlyFailed: 'Sadece Başarısız',
        processing: 'İşleniyor',
        taskId: 'Görev ID',
        model: 'Model',
        status: 'Durum',
        latency: 'Gecikme',
        cost: 'Maliyet',
        time: 'Zaman',
        success: 'Başarılı',
        failed: 'Başarısız',
        noRecords: 'Geçmiş kaydı yok',
        loadMore: 'Daha Fazla Yükle',
        noMore: 'Daha fazla yok',
        requestId: 'İstek ID',
        method: 'Yöntem',
        operationType: 'Tür',
        duration: 'Süre',
        costCredits: 'Maliyet (Kredi)',
        paginationText: '{from} ile {to} arası gösteriliyor, toplam {total} kayıt',

        // Contact sayfası
        needHelp: 'Yardıma mı ihtiyacınız var?',
        contactDesc:
            'API entegrasyon sorunları, kurumsal özelleştirme ihtiyaçları veya kota artışları olsun, teknik ekibimiz 24 saat içinde yanıt verecektir.',
        techSupport: 'Teknik Destek E-postası',
        supportTime:
            'Pzt-Paz 09:00-23:00 (GMT+8). Kurumsal müşteriler 7x24 VIP desteğine erişebilir.',
        sendEmail: 'E-posta Gönder',
        viewDocs: 'Belgeleri Görüntüle',

        // Pricing sayfası
        pricingTitle: 'Fiyatlandırma ve Faturalandırma',
        pricingDesc: 'Esnek kullandıkça öde modeli.',
        currentBalance: 'Mevcut Bakiye',
        credits: 'Kredi',
        billingRecords: 'Fatura Kayıtları',
        buyCredits: 'Kredi Satın Al',
        priceLabel: 'Fiyat',
        creditsLabel: 'Kredi',
        unitPrice: 'Birim Fiyat',
        loading: 'Yükleniyor...',
        buySelected: 'Seçili Paketi Satın Al',
        modelRates: 'Model Kullanım Oranları',
        modelLabel: 'Model',
        consumptionLabel: 'Tüketim',
        weryPrice: 'Wery Fiyatı',
        competitorA: 'Rakip A',
        competitorB: 'Rakip B',
    },
}
